/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as appRouteRouteImport } from './routes/(app)/route'
import { Route as appIndexRouteImport } from './routes/(app)/index'
import { Route as unauthenticatedTermsRouteImport } from './routes/(unauthenticated)/terms'
import { Route as unauthenticatedSignupRouteImport } from './routes/(unauthenticated)/signup'
import { Route as unauthenticatedOrganizationSelectorIndexRouteImport } from './routes/(unauthenticated)/organization-selector/index'
import { Route as unauthenticatedLinkIdentityIndexRouteImport } from './routes/(unauthenticated)/link-identity/index'
import { Route as appProfileIndexRouteImport } from './routes/(app)/profile/index'
import { Route as appOrgIndexRouteImport } from './routes/(app)/org/index'
import { Route as appInvitesIndexRouteImport } from './routes/(app)/invites/index'
import { Route as unauthenticatedOrganizationsStartRouteImport } from './routes/(unauthenticated)/organizations/start'
import { Route as unauthenticatedLinkIdentityCallbackRouteImport } from './routes/(unauthenticated)/link-identity/callback'
import { Route as unauthenticatedOrganizationsInvitesRouteRouteImport } from './routes/(unauthenticated)/organizations/invites/route'
import { Route as appOrgOrgRouteRouteImport } from './routes/(app)/org/$org/route'
import { Route as appOrgOrgIndexRouteImport } from './routes/(app)/org/$org/index'
import { Route as unauthenticatedOrganizationsInvitesAcceptRouteImport } from './routes/(unauthenticated)/organizations/invites/accept'
import { Route as appOrgIdOrgIdSplatRouteImport } from './routes/(app)/org-id/$orgId/$'
import { Route as appIntegrationsSlackCallbackRouteImport } from './routes/(app)/integrations/slack/callback'
import { Route as appIntegrationsJiraCallbackRouteImport } from './routes/(app)/integrations/jira/callback'
import { Route as appOrgOrgSettingsRouteRouteImport } from './routes/(app)/org/$org/settings/route'
import { Route as appOrgOrgLoopRouteRouteImport } from './routes/(app)/org/$org/loop/route'
import { Route as appOrgOrgIdeaManagementRouteRouteImport } from './routes/(app)/org/$org/idea-management/route'
import { Route as unauthenticatedOrganizationsInvitesErrorIndexRouteImport } from './routes/(unauthenticated)/organizations/invites/error/index'
import { Route as appOrgOrgVisualizationsIndexRouteImport } from './routes/(app)/org/$org/visualizations/index'
import { Route as appOrgOrgSettingsIndexRouteImport } from './routes/(app)/org/$org/settings/index'
import { Route as appOrgOrgObjectivesIndexRouteImport } from './routes/(app)/org/$org/objectives/index'
import { Route as appOrgOrgNotificationsIndexRouteImport } from './routes/(app)/org/$org/notifications/index'
import { Route as appOrgOrgNangoPlaygroundIndexRouteImport } from './routes/(app)/org/$org/nango-playground/index'
import { Route as appOrgOrgIdeaManagementIndexRouteImport } from './routes/(app)/org/$org/idea-management/index'
import { Route as appOrgOrgAllItemsIndexRouteImport } from './routes/(app)/org/$org/all-items/index'
import { Route as unauthenticatedPublishedV1TimelineLinkIdRouteImport } from './routes/(unauthenticated)/published/v1/timeline/$linkId'
import { Route as unauthenticatedPublishedV1SwimlaneLinkIdRouteImport } from './routes/(unauthenticated)/published/v1/swimlane/$linkId'
import { Route as appOrgOrgIdeaManagementPriorityFrameworksRouteImport } from './routes/(app)/org/$org/idea-management/priority-frameworks'
import { Route as appOrgOrgIdeaManagementOverviewRouteImport } from './routes/(app)/org/$org/idea-management/overview'
import { Route as appOrgOrgIdeaManagementCustomFieldsRouteImport } from './routes/(app)/org/$org/idea-management/custom-fields'
import { Route as appOrgOrgIdeaManagementComponentGalleryRouteImport } from './routes/(app)/org/$org/idea-management/component-gallery'
import { Route as appOrgOrgSettingsUserManagementRouteRouteImport } from './routes/(app)/org/$org/settings/user-management/route'
import { Route as appOrgOrgSettingsTeamsRouteRouteImport } from './routes/(app)/org/$org/settings/teams/route'
import { Route as appOrgOrgSettingsSubscriptionsRouteRouteImport } from './routes/(app)/org/$org/settings/subscriptions/route'
import { Route as appOrgOrgSettingsSkillsRouteRouteImport } from './routes/(app)/org/$org/settings/skills/route'
import { Route as appOrgOrgSettingsRolesRouteRouteImport } from './routes/(app)/org/$org/settings/roles/route'
import { Route as appOrgOrgSettingsPeopleRouteRouteImport } from './routes/(app)/org/$org/settings/people/route'
import { Route as appOrgOrgSettingsOrganizationRouteRouteImport } from './routes/(app)/org/$org/settings/organization/route'
import { Route as appOrgOrgSettingsOauthClientsRouteRouteImport } from './routes/(app)/org/$org/settings/oauth-clients/route'
import { Route as appOrgOrgSettingsLocationRouteRouteImport } from './routes/(app)/org/$org/settings/location/route'
import { Route as appOrgOrgSettingsDomainsRouteRouteImport } from './routes/(app)/org/$org/settings/domains/route'
import { Route as appOrgOrgSettingsConnectionsRouteRouteImport } from './routes/(app)/org/$org/settings/connections/route'
import { Route as appOrgOrgSettingsCapacityRouteRouteImport } from './routes/(app)/org/$org/settings/capacity/route'
import { Route as appOrgOrgLoopLoopIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/route'
import { Route as appOrgOrgIdeaManagementPortalsRouteRouteImport } from './routes/(app)/org/$org/idea-management/portals/route'
import { Route as appOrgOrgIdeaManagementInboxRouteRouteImport } from './routes/(app)/org/$org/idea-management/inbox/route'
import { Route as appOrgOrgSettingsWorkIntegrationsIndexRouteImport } from './routes/(app)/org/$org/settings/work-integrations/index'
import { Route as appOrgOrgSettingsUserManagementIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/index'
import { Route as appOrgOrgSettingsTeamsIndexRouteImport } from './routes/(app)/org/$org/settings/teams/index'
import { Route as appOrgOrgSettingsSubscriptionsIndexRouteImport } from './routes/(app)/org/$org/settings/subscriptions/index'
import { Route as appOrgOrgSettingsSkillsIndexRouteImport } from './routes/(app)/org/$org/settings/skills/index'
import { Route as appOrgOrgSettingsRolesIndexRouteImport } from './routes/(app)/org/$org/settings/roles/index'
import { Route as appOrgOrgSettingsPeopleIndexRouteImport } from './routes/(app)/org/$org/settings/people/index'
import { Route as appOrgOrgSettingsOrganizationIndexRouteImport } from './routes/(app)/org/$org/settings/organization/index'
import { Route as appOrgOrgSettingsOauthClientsIndexRouteImport } from './routes/(app)/org/$org/settings/oauth-clients/index'
import { Route as appOrgOrgSettingsNotificationsIndexRouteImport } from './routes/(app)/org/$org/settings/notifications/index'
import { Route as appOrgOrgSettingsLocationIndexRouteImport } from './routes/(app)/org/$org/settings/location/index'
import { Route as appOrgOrgSettingsItemTypesIndexRouteImport } from './routes/(app)/org/$org/settings/item-types/index'
import { Route as appOrgOrgSettingsEffortEstimationIndexRouteImport } from './routes/(app)/org/$org/settings/effort-estimation/index'
import { Route as appOrgOrgSettingsDomainsIndexRouteImport } from './routes/(app)/org/$org/settings/domains/index'
import { Route as appOrgOrgSettingsCustomItemStatusIndexRouteImport } from './routes/(app)/org/$org/settings/custom-item-status/index'
import { Route as appOrgOrgSettingsCustomFieldsIndexRouteImport } from './routes/(app)/org/$org/settings/custom-fields/index'
import { Route as appOrgOrgSettingsConnectionsIndexRouteImport } from './routes/(app)/org/$org/settings/connections/index'
import { Route as appOrgOrgSettingsCapacityIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/index'
import { Route as appOrgOrgSettingsAuditIndexRouteImport } from './routes/(app)/org/$org/settings/audit/index'
import { Route as appOrgOrgLoopLoopIdIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/index'
import { Route as appOrgOrgIdeaManagementProductAreasIndexRouteImport } from './routes/(app)/org/$org/idea-management/product-areas/index'
import { Route as appOrgOrgIdeaManagementPortalsIndexRouteImport } from './routes/(app)/org/$org/idea-management/portals/index'
import { Route as appOrgOrgIdeaManagementInboxIndexRouteImport } from './routes/(app)/org/$org/idea-management/inbox/index'
import { Route as appOrgOrgIdeaManagementIdeasIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/index'
import { Route as appOrgOrgIdeaManagementCustomersIndexRouteImport } from './routes/(app)/org/$org/idea-management/customers/index'
import { Route as appOrgOrgSettingsOauthClientsIdRouteImport } from './routes/(app)/org/$org/settings/oauth-clients/$id'
import { Route as appOrgOrgSettingsNotificationsSlack_app_healthRouteImport } from './routes/(app)/org/$org/settings/notifications/slack_app_health'
import { Route as appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteImport } from './routes/(app)/org/$org/settings/work-integrations/$integrationId/route'
import { Route as appOrgOrgSettingsUserManagementUsersRouteRouteImport } from './routes/(app)/org/$org/settings/user-management/users/route'
import { Route as appOrgOrgSettingsNotificationsSubscriptionsRouteRouteImport } from './routes/(app)/org/$org/settings/notifications/subscriptions/route'
import { Route as appOrgOrgLoopLoopIdVisualizationsRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/route'
import { Route as appOrgOrgLoopLoopIdTeamsRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/teams/route'
import { Route as appOrgOrgLoopLoopIdPortfolioRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/route'
import { Route as appOrgOrgLoopLoopIdPlannerRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/route'
import { Route as appOrgOrgLoopLoopIdInsightsRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/insights/route'
import { Route as appOrgOrgLoopLoopIdDashboardRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/dashboard/route'
import { Route as appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRouteImport } from './routes/(app)/org/$org/settings/work-integrations/$integrationId/index'
import { Route as appOrgOrgSettingsUserManagementUsersIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/users/index'
import { Route as appOrgOrgSettingsUserManagementInvitesIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/invites/index'
import { Route as appOrgOrgSettingsNotificationsSubscriptionsIndexRouteImport } from './routes/(app)/org/$org/settings/notifications/subscriptions/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/index'
import { Route as appOrgOrgLoopLoopIdTeamsIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/teams/index'
import { Route as appOrgOrgLoopLoopIdPortfolioIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/index'
import { Route as appOrgOrgLoopLoopIdPlannerIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/index'
import { Route as appOrgOrgLoopLoopIdOverviewIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/overview/index'
import { Route as appOrgOrgLoopLoopIdIntegrationsIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/integrations/index'
import { Route as appOrgOrgLoopLoopIdInsightsIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/insights/index'
import { Route as appOrgOrgLoopLoopIdDashboardIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/dashboard/index'
import { Route as appOrgOrgIdeaManagementProductAreasCreateIndexRouteImport } from './routes/(app)/org/$org/idea-management/product-areas/create/index'
import { Route as appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRouteImport } from './routes/(app)/org/$org/idea-management/product-areas/$productAreaId/index'
import { Route as appOrgOrgIdeaManagementPortalsCreateIndexRouteImport } from './routes/(app)/org/$org/idea-management/portals/create/index'
import { Route as appOrgOrgIdeaManagementPortalsPortalIdIndexRouteImport } from './routes/(app)/org/$org/idea-management/portals/$portalId/index'
import { Route as appOrgOrgIdeaManagementIdeasViewIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/view/index'
import { Route as appOrgOrgIdeaManagementIdeasCreateIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/create/index'
import { Route as appOrgOrgIdeaManagementIdeasCompletedIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/completed/index'
import { Route as appOrgOrgIdeaManagementIdeasAllIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/all/index'
import { Route as appOrgOrgSettingsTeamsTeamTeamIdRouteRouteImport } from './routes/(app)/org/$org/settings/teams/team/$teamId/route'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/route'
import { Route as appOrgOrgLoopLoopIdPlannerSandboxRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/sandbox/route'
import { Route as appOrgOrgLoopLoopIdInsightsInsightIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/insights/$insightId/route'
import { Route as appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRouteImport } from './routes/(app)/org/$org/settings/work-integrations/$integrationId/logs/index'
import { Route as appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRouteImport } from './routes/(app)/org/$org/settings/work-integrations/$integrationId/issues/index'
import { Route as appOrgOrgSettingsUserManagementUsersUserIdIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/users/$userId/index'
import { Route as appOrgOrgSettingsTeamsTeamTeamIdIndexRouteImport } from './routes/(app)/org/$org/settings/teams/team/$teamId/index'
import { Route as appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRouteImport } from './routes/(app)/org/$org/settings/notifications/subscriptions/idea-manager/index'
import { Route as appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/index'
import { Route as appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/index'
import { Route as appOrgOrgLoopLoopIdPlannerSandboxIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/sandbox/index'
import { Route as appOrgOrgLoopLoopIdDashboardDeliverablesIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/dashboard/deliverables/index'
import { Route as appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRouteImport } from './routes/(app)/org/$org/idea-management/portals/$portalId/$formId/index'
import { Route as appOrgOrgIdeaManagementIdeasViewViewIdIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/view/$viewId/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/route'
import { Route as appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/route'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/timeline/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainTableIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/table/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId/index'
import { Route as appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/index'
import { Route as appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/sandbox/timeline/index'
import { Route as appOrgOrgLoopLoopIdPlannerSandboxTableIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/sandbox/table/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/table/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/index'
import { Route as appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/index'
import { Route as appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/index'
import { Route as unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png/route'
import { Route as unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf/route'
import { Route as unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png/route'
import { Route as unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf/route'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId/route'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId/route'

const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const appIndexRoute = appIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appRouteRoute,
} as any)
const unauthenticatedTermsRoute = unauthenticatedTermsRouteImport.update({
  id: '/(unauthenticated)/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const unauthenticatedSignupRoute = unauthenticatedSignupRouteImport.update({
  id: '/(unauthenticated)/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const unauthenticatedOrganizationSelectorIndexRoute =
  unauthenticatedOrganizationSelectorIndexRouteImport.update({
    id: '/(unauthenticated)/organization-selector/',
    path: '/organization-selector/',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedLinkIdentityIndexRoute =
  unauthenticatedLinkIdentityIndexRouteImport.update({
    id: '/(unauthenticated)/link-identity/',
    path: '/link-identity/',
    getParentRoute: () => rootRouteImport,
  } as any)
const appProfileIndexRoute = appProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => appRouteRoute,
} as any)
const appOrgIndexRoute = appOrgIndexRouteImport.update({
  id: '/org/',
  path: '/org/',
  getParentRoute: () => appRouteRoute,
} as any)
const appInvitesIndexRoute = appInvitesIndexRouteImport.update({
  id: '/invites/',
  path: '/invites/',
  getParentRoute: () => appRouteRoute,
} as any)
const unauthenticatedOrganizationsStartRoute =
  unauthenticatedOrganizationsStartRouteImport.update({
    id: '/(unauthenticated)/organizations/start',
    path: '/organizations/start',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedLinkIdentityCallbackRoute =
  unauthenticatedLinkIdentityCallbackRouteImport.update({
    id: '/(unauthenticated)/link-identity/callback',
    path: '/link-identity/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedOrganizationsInvitesRouteRoute =
  unauthenticatedOrganizationsInvitesRouteRouteImport.update({
    id: '/(unauthenticated)/organizations/invites',
    path: '/organizations/invites',
    getParentRoute: () => rootRouteImport,
  } as any)
const appOrgOrgRouteRoute = appOrgOrgRouteRouteImport.update({
  id: '/org/$org',
  path: '/org/$org',
  getParentRoute: () => appRouteRoute,
} as any)
const appOrgOrgIndexRoute = appOrgOrgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const unauthenticatedOrganizationsInvitesAcceptRoute =
  unauthenticatedOrganizationsInvitesAcceptRouteImport.update({
    id: '/accept',
    path: '/accept',
    getParentRoute: () => unauthenticatedOrganizationsInvitesRouteRoute,
  } as any)
const appOrgIdOrgIdSplatRoute = appOrgIdOrgIdSplatRouteImport.update({
  id: '/org-id/$orgId/$',
  path: '/org-id/$orgId/$',
  getParentRoute: () => appRouteRoute,
} as any)
const appIntegrationsSlackCallbackRoute =
  appIntegrationsSlackCallbackRouteImport.update({
    id: '/integrations/slack/callback',
    path: '/integrations/slack/callback',
    getParentRoute: () => appRouteRoute,
  } as any)
const appIntegrationsJiraCallbackRoute =
  appIntegrationsJiraCallbackRouteImport.update({
    id: '/integrations/jira/callback',
    path: '/integrations/jira/callback',
    getParentRoute: () => appRouteRoute,
  } as any)
const appOrgOrgSettingsRouteRoute = appOrgOrgSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgLoopRouteRoute = appOrgOrgLoopRouteRouteImport.update({
  id: '/loop',
  path: '/loop',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgIdeaManagementRouteRoute =
  appOrgOrgIdeaManagementRouteRouteImport.update({
    id: '/idea-management',
    path: '/idea-management',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const unauthenticatedOrganizationsInvitesErrorIndexRoute =
  unauthenticatedOrganizationsInvitesErrorIndexRouteImport.update({
    id: '/error/',
    path: '/error/',
    getParentRoute: () => unauthenticatedOrganizationsInvitesRouteRoute,
  } as any)
const appOrgOrgVisualizationsIndexRoute =
  appOrgOrgVisualizationsIndexRouteImport.update({
    id: '/visualizations/',
    path: '/visualizations/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgSettingsIndexRoute = appOrgOrgSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgSettingsRouteRoute,
} as any)
const appOrgOrgObjectivesIndexRoute =
  appOrgOrgObjectivesIndexRouteImport.update({
    id: '/objectives/',
    path: '/objectives/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgNotificationsIndexRoute =
  appOrgOrgNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgNangoPlaygroundIndexRoute =
  appOrgOrgNangoPlaygroundIndexRouteImport.update({
    id: '/nango-playground/',
    path: '/nango-playground/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIndexRoute =
  appOrgOrgIdeaManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgAllItemsIndexRoute = appOrgOrgAllItemsIndexRouteImport.update({
  id: '/all-items/',
  path: '/all-items/',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const unauthenticatedPublishedV1TimelineLinkIdRoute =
  unauthenticatedPublishedV1TimelineLinkIdRouteImport.update({
    id: '/(unauthenticated)/published/v1/timeline/$linkId',
    path: '/published/v1/timeline/$linkId',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedPublishedV1SwimlaneLinkIdRoute =
  unauthenticatedPublishedV1SwimlaneLinkIdRouteImport.update({
    id: '/(unauthenticated)/published/v1/swimlane/$linkId',
    path: '/published/v1/swimlane/$linkId',
    getParentRoute: () => rootRouteImport,
  } as any)
const appOrgOrgIdeaManagementPriorityFrameworksRoute =
  appOrgOrgIdeaManagementPriorityFrameworksRouteImport.update({
    id: '/priority-frameworks',
    path: '/priority-frameworks',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementOverviewRoute =
  appOrgOrgIdeaManagementOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementCustomFieldsRoute =
  appOrgOrgIdeaManagementCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementComponentGalleryRoute =
  appOrgOrgIdeaManagementComponentGalleryRouteImport.update({
    id: '/component-gallery',
    path: '/component-gallery',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementRouteRoute =
  appOrgOrgSettingsUserManagementRouteRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsTeamsRouteRoute =
  appOrgOrgSettingsTeamsRouteRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsSubscriptionsRouteRoute =
  appOrgOrgSettingsSubscriptionsRouteRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsSkillsRouteRoute =
  appOrgOrgSettingsSkillsRouteRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsRolesRouteRoute =
  appOrgOrgSettingsRolesRouteRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsPeopleRouteRoute =
  appOrgOrgSettingsPeopleRouteRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsOrganizationRouteRoute =
  appOrgOrgSettingsOrganizationRouteRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsOauthClientsRouteRoute =
  appOrgOrgSettingsOauthClientsRouteRouteImport.update({
    id: '/oauth-clients',
    path: '/oauth-clients',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsLocationRouteRoute =
  appOrgOrgSettingsLocationRouteRouteImport.update({
    id: '/location',
    path: '/location',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsDomainsRouteRoute =
  appOrgOrgSettingsDomainsRouteRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsConnectionsRouteRoute =
  appOrgOrgSettingsConnectionsRouteRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityRouteRoute =
  appOrgOrgSettingsCapacityRouteRouteImport.update({
    id: '/capacity',
    path: '/capacity',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdRouteRoute =
  appOrgOrgLoopLoopIdRouteRouteImport.update({
    id: '/$loopId',
    path: '/$loopId',
    getParentRoute: () => appOrgOrgLoopRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPortalsRouteRoute =
  appOrgOrgIdeaManagementPortalsRouteRouteImport.update({
    id: '/portals',
    path: '/portals',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementInboxRouteRoute =
  appOrgOrgIdeaManagementInboxRouteRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgSettingsWorkIntegrationsIndexRoute =
  appOrgOrgSettingsWorkIntegrationsIndexRouteImport.update({
    id: '/work-integrations/',
    path: '/work-integrations/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementIndexRoute =
  appOrgOrgSettingsUserManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsUserManagementRouteRoute,
  } as any)
const appOrgOrgSettingsTeamsIndexRoute =
  appOrgOrgSettingsTeamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsTeamsRouteRoute,
  } as any)
const appOrgOrgSettingsSubscriptionsIndexRoute =
  appOrgOrgSettingsSubscriptionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsSubscriptionsRouteRoute,
  } as any)
const appOrgOrgSettingsSkillsIndexRoute =
  appOrgOrgSettingsSkillsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsSkillsRouteRoute,
  } as any)
const appOrgOrgSettingsRolesIndexRoute =
  appOrgOrgSettingsRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsRolesRouteRoute,
  } as any)
const appOrgOrgSettingsPeopleIndexRoute =
  appOrgOrgSettingsPeopleIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsPeopleRouteRoute,
  } as any)
const appOrgOrgSettingsOrganizationIndexRoute =
  appOrgOrgSettingsOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsOrganizationRouteRoute,
  } as any)
const appOrgOrgSettingsOauthClientsIndexRoute =
  appOrgOrgSettingsOauthClientsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsOauthClientsRouteRoute,
  } as any)
const appOrgOrgSettingsNotificationsIndexRoute =
  appOrgOrgSettingsNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsLocationIndexRoute =
  appOrgOrgSettingsLocationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsLocationRouteRoute,
  } as any)
const appOrgOrgSettingsItemTypesIndexRoute =
  appOrgOrgSettingsItemTypesIndexRouteImport.update({
    id: '/item-types/',
    path: '/item-types/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsEffortEstimationIndexRoute =
  appOrgOrgSettingsEffortEstimationIndexRouteImport.update({
    id: '/effort-estimation/',
    path: '/effort-estimation/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsDomainsIndexRoute =
  appOrgOrgSettingsDomainsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsDomainsRouteRoute,
  } as any)
const appOrgOrgSettingsCustomItemStatusIndexRoute =
  appOrgOrgSettingsCustomItemStatusIndexRouteImport.update({
    id: '/custom-item-status/',
    path: '/custom-item-status/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsCustomFieldsIndexRoute =
  appOrgOrgSettingsCustomFieldsIndexRouteImport.update({
    id: '/custom-fields/',
    path: '/custom-fields/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsConnectionsIndexRoute =
  appOrgOrgSettingsConnectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsConnectionsRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityIndexRoute =
  appOrgOrgSettingsCapacityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
  } as any)
const appOrgOrgSettingsAuditIndexRoute =
  appOrgOrgSettingsAuditIndexRouteImport.update({
    id: '/audit/',
    path: '/audit/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdIndexRoute =
  appOrgOrgLoopLoopIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgIdeaManagementProductAreasIndexRoute =
  appOrgOrgIdeaManagementProductAreasIndexRouteImport.update({
    id: '/product-areas/',
    path: '/product-areas/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPortalsIndexRoute =
  appOrgOrgIdeaManagementPortalsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgIdeaManagementPortalsRouteRoute,
  } as any)
const appOrgOrgIdeaManagementInboxIndexRoute =
  appOrgOrgIdeaManagementInboxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgIdeaManagementInboxRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasIndexRoute =
  appOrgOrgIdeaManagementIdeasIndexRouteImport.update({
    id: '/ideas/',
    path: '/ideas/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementCustomersIndexRoute =
  appOrgOrgIdeaManagementCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgSettingsOauthClientsIdRoute =
  appOrgOrgSettingsOauthClientsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => appOrgOrgSettingsOauthClientsRouteRoute,
  } as any)
const appOrgOrgSettingsNotificationsSlack_app_healthRoute =
  appOrgOrgSettingsNotificationsSlack_app_healthRouteImport.update({
    id: '/notifications/slack_app_health',
    path: '/notifications/slack_app_health',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute =
  appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteImport.update({
    id: '/work-integrations/$integrationId',
    path: '/work-integrations/$integrationId',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementUsersRouteRoute =
  appOrgOrgSettingsUserManagementUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => appOrgOrgSettingsUserManagementRouteRoute,
  } as any)
const appOrgOrgSettingsNotificationsSubscriptionsRouteRoute =
  appOrgOrgSettingsNotificationsSubscriptionsRouteRouteImport.update({
    id: '/notifications/subscriptions',
    path: '/notifications/subscriptions',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsRouteRoute =
  appOrgOrgLoopLoopIdVisualizationsRouteRouteImport.update({
    id: '/visualizations',
    path: '/visualizations',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdTeamsRouteRoute =
  appOrgOrgLoopLoopIdTeamsRouteRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioRouteRoute =
  appOrgOrgLoopLoopIdPortfolioRouteRouteImport.update({
    id: '/portfolio',
    path: '/portfolio',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerRouteRoute =
  appOrgOrgLoopLoopIdPlannerRouteRouteImport.update({
    id: '/planner',
    path: '/planner',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdInsightsRouteRoute =
  appOrgOrgLoopLoopIdInsightsRouteRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdDashboardRouteRoute =
  appOrgOrgLoopLoopIdDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute =
  appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementUsersIndexRoute =
  appOrgOrgSettingsUserManagementUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsUserManagementUsersRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementInvitesIndexRoute =
  appOrgOrgSettingsUserManagementInvitesIndexRouteImport.update({
    id: '/invites/',
    path: '/invites/',
    getParentRoute: () => appOrgOrgSettingsUserManagementRouteRoute,
  } as any)
const appOrgOrgSettingsNotificationsSubscriptionsIndexRoute =
  appOrgOrgSettingsNotificationsSubscriptionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsNotificationsSubscriptionsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdTeamsIndexRoute =
  appOrgOrgLoopLoopIdTeamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdTeamsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioIndexRoute =
  appOrgOrgLoopLoopIdPortfolioIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerIndexRoute =
  appOrgOrgLoopLoopIdPlannerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdOverviewIndexRoute =
  appOrgOrgLoopLoopIdOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdIntegrationsIndexRoute =
  appOrgOrgLoopLoopIdIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdInsightsIndexRoute =
  appOrgOrgLoopLoopIdInsightsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdInsightsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdDashboardIndexRoute =
  appOrgOrgLoopLoopIdDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdDashboardRouteRoute,
  } as any)
const appOrgOrgIdeaManagementProductAreasCreateIndexRoute =
  appOrgOrgIdeaManagementProductAreasCreateIndexRouteImport.update({
    id: '/product-areas/create/',
    path: '/product-areas/create/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute =
  appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRouteImport.update({
    id: '/product-areas/$productAreaId/',
    path: '/product-areas/$productAreaId/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPortalsCreateIndexRoute =
  appOrgOrgIdeaManagementPortalsCreateIndexRouteImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => appOrgOrgIdeaManagementPortalsRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPortalsPortalIdIndexRoute =
  appOrgOrgIdeaManagementPortalsPortalIdIndexRouteImport.update({
    id: '/$portalId/',
    path: '/$portalId/',
    getParentRoute: () => appOrgOrgIdeaManagementPortalsRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasViewIndexRoute =
  appOrgOrgIdeaManagementIdeasViewIndexRouteImport.update({
    id: '/ideas/view/',
    path: '/ideas/view/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasCreateIndexRoute =
  appOrgOrgIdeaManagementIdeasCreateIndexRouteImport.update({
    id: '/ideas/create/',
    path: '/ideas/create/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasCompletedIndexRoute =
  appOrgOrgIdeaManagementIdeasCompletedIndexRouteImport.update({
    id: '/ideas/completed/',
    path: '/ideas/completed/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasAllIndexRoute =
  appOrgOrgIdeaManagementIdeasAllIndexRouteImport.update({
    id: '/ideas/all/',
    path: '/ideas/all/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgSettingsTeamsTeamTeamIdRouteRoute =
  appOrgOrgSettingsTeamsTeamTeamIdRouteRouteImport.update({
    id: '/team/$teamId',
    path: '/team/$teamId',
    getParentRoute: () => appOrgOrgSettingsTeamsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainRouteRoute =
  appOrgOrgLoopLoopIdVisualizationsMainRouteRouteImport.update({
    id: '/main',
    path: '/main',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerSandboxRouteRoute =
  appOrgOrgLoopLoopIdPlannerSandboxRouteRouteImport.update({
    id: '/sandbox',
    path: '/sandbox',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdInsightsInsightIdRouteRoute =
  appOrgOrgLoopLoopIdInsightsInsightIdRouteRouteImport.update({
    id: '/$insightId',
    path: '/$insightId',
    getParentRoute: () => appOrgOrgLoopLoopIdInsightsRouteRoute,
  } as any)
const appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute =
  appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRouteImport.update({
    id: '/logs/',
    path: '/logs/',
    getParentRoute: () =>
      appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute,
  } as any)
const appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute =
  appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRouteImport.update({
    id: '/issues/',
    path: '/issues/',
    getParentRoute: () =>
      appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementUsersUserIdIndexRoute =
  appOrgOrgSettingsUserManagementUsersUserIdIndexRouteImport.update({
    id: '/$userId/',
    path: '/$userId/',
    getParentRoute: () => appOrgOrgSettingsUserManagementUsersRouteRoute,
  } as any)
const appOrgOrgSettingsTeamsTeamTeamIdIndexRoute =
  appOrgOrgSettingsTeamsTeamTeamIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsTeamsTeamTeamIdRouteRoute,
  } as any)
const appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute =
  appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRouteImport.update(
    {
      id: '/idea-manager/',
      path: '/idea-manager/',
      getParentRoute: () =>
        appOrgOrgSettingsNotificationsSubscriptionsRouteRoute,
    } as any,
  )
const appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute =
  appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRouteImport.update(
    {
      id: '/workload-scheme/$workloadSchemeId/',
      path: '/workload-scheme/$workloadSchemeId/',
      getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
    } as any,
  )
const appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute =
  appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRouteImport.update({
    id: '/holiday-scheme/$holidaySchemeId/',
    path: '/holiday-scheme/$holidaySchemeId/',
    getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsMainIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsMainRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerSandboxIndexRoute =
  appOrgOrgLoopLoopIdPlannerSandboxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerSandboxRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute =
  appOrgOrgLoopLoopIdDashboardDeliverablesIndexRouteImport.update({
    id: '/deliverables/',
    path: '/deliverables/',
    getParentRoute: () => appOrgOrgLoopLoopIdDashboardRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute =
  appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRouteImport.update({
    id: '/$portalId/$formId/',
    path: '/$portalId/$formId/',
    getParentRoute: () => appOrgOrgIdeaManagementPortalsRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute =
  appOrgOrgIdeaManagementIdeasViewViewIdIndexRouteImport.update({
    id: '/ideas/view/$viewId/',
    path: '/ideas/view/$viewId/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteImport.update({
    id: '/view/$viewId',
    path: '/view/$viewId',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteImport.update({
    id: '/scenario/$scenarioId',
    path: '/scenario/$scenarioId',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsMainRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsMainTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsMainRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRouteImport.update({
    id: '/swimlane/',
    path: '/swimlane/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsMainRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRouteImport.update({
    id: '/dashboard/$dashboardId/',
    path: '/dashboard/$dashboardId/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRoute =
  appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerSandboxRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerSandboxTableIndexRoute =
  appOrgOrgLoopLoopIdPlannerSandboxTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerSandboxRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRouteImport.update({
    id: '/swimlane/',
    path: '/swimlane/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () =>
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () =>
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute,
  } as any)
const unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute =
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png',
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute =
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf',
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute =
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png',
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute =
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf',
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRouteImport.update(
    {
      id: '/timeline/preview/$visualizationId',
      path: '/timeline/preview/$visualizationId',
      getParentRoute: () =>
        appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
    } as any,
  )
const appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRouteImport.update(
    {
      id: '/swimlane/preview/$visualizationId',
      path: '/swimlane/preview/$visualizationId',
      getParentRoute: () =>
        appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/signup': typeof unauthenticatedSignupRoute
  '/terms': typeof unauthenticatedTermsRoute
  '/': typeof appIndexRoute
  '/org/$org': typeof appOrgOrgRouteRouteWithChildren
  '/organizations/invites': typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  '/link-identity/callback': typeof unauthenticatedLinkIdentityCallbackRoute
  '/organizations/start': typeof unauthenticatedOrganizationsStartRoute
  '/invites/': typeof appInvitesIndexRoute
  '/org/': typeof appOrgIndexRoute
  '/profile/': typeof appProfileIndexRoute
  '/link-identity/': typeof unauthenticatedLinkIdentityIndexRoute
  '/organization-selector/': typeof unauthenticatedOrganizationSelectorIndexRoute
  '/org/$org/idea-management': typeof appOrgOrgIdeaManagementRouteRouteWithChildren
  '/org/$org/loop': typeof appOrgOrgLoopRouteRouteWithChildren
  '/org/$org/settings': typeof appOrgOrgSettingsRouteRouteWithChildren
  '/integrations/jira/callback': typeof appIntegrationsJiraCallbackRoute
  '/integrations/slack/callback': typeof appIntegrationsSlackCallbackRoute
  '/org-id/$orgId/$': typeof appOrgIdOrgIdSplatRoute
  '/organizations/invites/accept': typeof unauthenticatedOrganizationsInvitesAcceptRoute
  '/org/$org/': typeof appOrgOrgIndexRoute
  '/org/$org/idea-management/inbox': typeof appOrgOrgIdeaManagementInboxRouteRouteWithChildren
  '/org/$org/idea-management/portals': typeof appOrgOrgIdeaManagementPortalsRouteRouteWithChildren
  '/org/$org/loop/$loopId': typeof appOrgOrgLoopLoopIdRouteRouteWithChildren
  '/org/$org/settings/capacity': typeof appOrgOrgSettingsCapacityRouteRouteWithChildren
  '/org/$org/settings/connections': typeof appOrgOrgSettingsConnectionsRouteRouteWithChildren
  '/org/$org/settings/domains': typeof appOrgOrgSettingsDomainsRouteRouteWithChildren
  '/org/$org/settings/location': typeof appOrgOrgSettingsLocationRouteRouteWithChildren
  '/org/$org/settings/oauth-clients': typeof appOrgOrgSettingsOauthClientsRouteRouteWithChildren
  '/org/$org/settings/organization': typeof appOrgOrgSettingsOrganizationRouteRouteWithChildren
  '/org/$org/settings/people': typeof appOrgOrgSettingsPeopleRouteRouteWithChildren
  '/org/$org/settings/roles': typeof appOrgOrgSettingsRolesRouteRouteWithChildren
  '/org/$org/settings/skills': typeof appOrgOrgSettingsSkillsRouteRouteWithChildren
  '/org/$org/settings/subscriptions': typeof appOrgOrgSettingsSubscriptionsRouteRouteWithChildren
  '/org/$org/settings/teams': typeof appOrgOrgSettingsTeamsRouteRouteWithChildren
  '/org/$org/settings/user-management': typeof appOrgOrgSettingsUserManagementRouteRouteWithChildren
  '/org/$org/idea-management/component-gallery': typeof appOrgOrgIdeaManagementComponentGalleryRoute
  '/org/$org/idea-management/custom-fields': typeof appOrgOrgIdeaManagementCustomFieldsRoute
  '/org/$org/idea-management/overview': typeof appOrgOrgIdeaManagementOverviewRoute
  '/org/$org/idea-management/priority-frameworks': typeof appOrgOrgIdeaManagementPriorityFrameworksRoute
  '/published/v1/swimlane/$linkId': typeof unauthenticatedPublishedV1SwimlaneLinkIdRoute
  '/published/v1/timeline/$linkId': typeof unauthenticatedPublishedV1TimelineLinkIdRoute
  '/org/$org/all-items/': typeof appOrgOrgAllItemsIndexRoute
  '/org/$org/idea-management/': typeof appOrgOrgIdeaManagementIndexRoute
  '/org/$org/nango-playground/': typeof appOrgOrgNangoPlaygroundIndexRoute
  '/org/$org/notifications/': typeof appOrgOrgNotificationsIndexRoute
  '/org/$org/objectives/': typeof appOrgOrgObjectivesIndexRoute
  '/org/$org/settings/': typeof appOrgOrgSettingsIndexRoute
  '/org/$org/visualizations/': typeof appOrgOrgVisualizationsIndexRoute
  '/organizations/invites/error/': typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
  '/org/$org/loop/$loopId/dashboard': typeof appOrgOrgLoopLoopIdDashboardRouteRouteWithChildren
  '/org/$org/loop/$loopId/insights': typeof appOrgOrgLoopLoopIdInsightsRouteRouteWithChildren
  '/org/$org/loop/$loopId/planner': typeof appOrgOrgLoopLoopIdPlannerRouteRouteWithChildren
  '/org/$org/loop/$loopId/portfolio': typeof appOrgOrgLoopLoopIdPortfolioRouteRouteWithChildren
  '/org/$org/loop/$loopId/teams': typeof appOrgOrgLoopLoopIdTeamsRouteRouteWithChildren
  '/org/$org/loop/$loopId/visualizations': typeof appOrgOrgLoopLoopIdVisualizationsRouteRouteWithChildren
  '/org/$org/settings/notifications/subscriptions': typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRouteWithChildren
  '/org/$org/settings/user-management/users': typeof appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren
  '/org/$org/settings/work-integrations/$integrationId': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteWithChildren
  '/org/$org/settings/notifications/slack_app_health': typeof appOrgOrgSettingsNotificationsSlack_app_healthRoute
  '/org/$org/settings/oauth-clients/$id': typeof appOrgOrgSettingsOauthClientsIdRoute
  '/org/$org/idea-management/customers/': typeof appOrgOrgIdeaManagementCustomersIndexRoute
  '/org/$org/idea-management/ideas/': typeof appOrgOrgIdeaManagementIdeasIndexRoute
  '/org/$org/idea-management/inbox/': typeof appOrgOrgIdeaManagementInboxIndexRoute
  '/org/$org/idea-management/portals/': typeof appOrgOrgIdeaManagementPortalsIndexRoute
  '/org/$org/idea-management/product-areas/': typeof appOrgOrgIdeaManagementProductAreasIndexRoute
  '/org/$org/loop/$loopId/': typeof appOrgOrgLoopLoopIdIndexRoute
  '/org/$org/settings/audit/': typeof appOrgOrgSettingsAuditIndexRoute
  '/org/$org/settings/capacity/': typeof appOrgOrgSettingsCapacityIndexRoute
  '/org/$org/settings/connections/': typeof appOrgOrgSettingsConnectionsIndexRoute
  '/org/$org/settings/custom-fields/': typeof appOrgOrgSettingsCustomFieldsIndexRoute
  '/org/$org/settings/custom-item-status/': typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  '/org/$org/settings/domains/': typeof appOrgOrgSettingsDomainsIndexRoute
  '/org/$org/settings/effort-estimation/': typeof appOrgOrgSettingsEffortEstimationIndexRoute
  '/org/$org/settings/item-types/': typeof appOrgOrgSettingsItemTypesIndexRoute
  '/org/$org/settings/location/': typeof appOrgOrgSettingsLocationIndexRoute
  '/org/$org/settings/notifications/': typeof appOrgOrgSettingsNotificationsIndexRoute
  '/org/$org/settings/oauth-clients/': typeof appOrgOrgSettingsOauthClientsIndexRoute
  '/org/$org/settings/organization/': typeof appOrgOrgSettingsOrganizationIndexRoute
  '/org/$org/settings/people/': typeof appOrgOrgSettingsPeopleIndexRoute
  '/org/$org/settings/roles/': typeof appOrgOrgSettingsRolesIndexRoute
  '/org/$org/settings/skills/': typeof appOrgOrgSettingsSkillsIndexRoute
  '/org/$org/settings/subscriptions/': typeof appOrgOrgSettingsSubscriptionsIndexRoute
  '/org/$org/settings/teams/': typeof appOrgOrgSettingsTeamsIndexRoute
  '/org/$org/settings/user-management/': typeof appOrgOrgSettingsUserManagementIndexRoute
  '/org/$org/settings/work-integrations/': typeof appOrgOrgSettingsWorkIntegrationsIndexRoute
  '/org/$org/loop/$loopId/insights/$insightId': typeof appOrgOrgLoopLoopIdInsightsInsightIdRouteRoute
  '/org/$org/loop/$loopId/planner/sandbox': typeof appOrgOrgLoopLoopIdPlannerSandboxRouteRouteWithChildren
  '/org/$org/loop/$loopId/visualizations/main': typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRouteWithChildren
  '/org/$org/settings/teams/team/$teamId': typeof appOrgOrgSettingsTeamsTeamTeamIdRouteRouteWithChildren
  '/org/$org/idea-management/ideas/all/': typeof appOrgOrgIdeaManagementIdeasAllIndexRoute
  '/org/$org/idea-management/ideas/completed/': typeof appOrgOrgIdeaManagementIdeasCompletedIndexRoute
  '/org/$org/idea-management/ideas/create/': typeof appOrgOrgIdeaManagementIdeasCreateIndexRoute
  '/org/$org/idea-management/ideas/view/': typeof appOrgOrgIdeaManagementIdeasViewIndexRoute
  '/org/$org/idea-management/portals/$portalId/': typeof appOrgOrgIdeaManagementPortalsPortalIdIndexRoute
  '/org/$org/idea-management/portals/create/': typeof appOrgOrgIdeaManagementPortalsCreateIndexRoute
  '/org/$org/idea-management/product-areas/$productAreaId/': typeof appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute
  '/org/$org/idea-management/product-areas/create/': typeof appOrgOrgIdeaManagementProductAreasCreateIndexRoute
  '/org/$org/loop/$loopId/dashboard/': typeof appOrgOrgLoopLoopIdDashboardIndexRoute
  '/org/$org/loop/$loopId/insights/': typeof appOrgOrgLoopLoopIdInsightsIndexRoute
  '/org/$org/loop/$loopId/integrations/': typeof appOrgOrgLoopLoopIdIntegrationsIndexRoute
  '/org/$org/loop/$loopId/overview/': typeof appOrgOrgLoopLoopIdOverviewIndexRoute
  '/org/$org/loop/$loopId/planner/': typeof appOrgOrgLoopLoopIdPlannerIndexRoute
  '/org/$org/loop/$loopId/portfolio/': typeof appOrgOrgLoopLoopIdPortfolioIndexRoute
  '/org/$org/loop/$loopId/teams/': typeof appOrgOrgLoopLoopIdTeamsIndexRoute
  '/org/$org/loop/$loopId/visualizations/': typeof appOrgOrgLoopLoopIdVisualizationsIndexRoute
  '/org/$org/settings/notifications/subscriptions/': typeof appOrgOrgSettingsNotificationsSubscriptionsIndexRoute
  '/org/$org/settings/user-management/invites/': typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
  '/org/$org/settings/user-management/users/': typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  '/org/$org/settings/work-integrations/$integrationId/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteWithChildren
  '/org/$org/loop/$loopId/visualizations/view/$viewId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteWithChildren
  '/org/$org/idea-management/ideas/view/$viewId/': typeof appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute
  '/org/$org/idea-management/portals/$portalId/$formId/': typeof appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute
  '/org/$org/loop/$loopId/dashboard/deliverables/': typeof appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute
  '/org/$org/loop/$loopId/planner/sandbox/': typeof appOrgOrgLoopLoopIdPlannerSandboxIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/': typeof appOrgOrgLoopLoopIdVisualizationsMainIndexRoute
  '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/': typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  '/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/': typeof appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute
  '/org/$org/settings/notifications/subscriptions/idea-manager/': typeof appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute
  '/org/$org/settings/teams/team/$teamId/': typeof appOrgOrgSettingsTeamsTeamTeamIdIndexRoute
  '/org/$org/settings/user-management/users/$userId/': typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
  '/org/$org/settings/work-integrations/$integrationId/issues/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute
  '/org/$org/settings/work-integrations/$integrationId/logs/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute
  '/org/$org/loop/$loopId/planner/sandbox/table/': typeof appOrgOrgLoopLoopIdPlannerSandboxTableIndexRoute
  '/org/$org/loop/$loopId/planner/sandbox/timeline/': typeof appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute
  '/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId/': typeof appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/swimlane/': typeof appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/table/': typeof appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/timeline/': typeof appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/table/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute
}
export interface FileRoutesByTo {
  '/signup': typeof unauthenticatedSignupRoute
  '/terms': typeof unauthenticatedTermsRoute
  '/': typeof appIndexRoute
  '/organizations/invites': typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  '/link-identity/callback': typeof unauthenticatedLinkIdentityCallbackRoute
  '/organizations/start': typeof unauthenticatedOrganizationsStartRoute
  '/invites': typeof appInvitesIndexRoute
  '/org': typeof appOrgIndexRoute
  '/profile': typeof appProfileIndexRoute
  '/link-identity': typeof unauthenticatedLinkIdentityIndexRoute
  '/organization-selector': typeof unauthenticatedOrganizationSelectorIndexRoute
  '/org/$org/loop': typeof appOrgOrgLoopRouteRouteWithChildren
  '/integrations/jira/callback': typeof appIntegrationsJiraCallbackRoute
  '/integrations/slack/callback': typeof appIntegrationsSlackCallbackRoute
  '/org-id/$orgId/$': typeof appOrgIdOrgIdSplatRoute
  '/organizations/invites/accept': typeof unauthenticatedOrganizationsInvitesAcceptRoute
  '/org/$org': typeof appOrgOrgIndexRoute
  '/org/$org/idea-management/component-gallery': typeof appOrgOrgIdeaManagementComponentGalleryRoute
  '/org/$org/idea-management/custom-fields': typeof appOrgOrgIdeaManagementCustomFieldsRoute
  '/org/$org/idea-management/overview': typeof appOrgOrgIdeaManagementOverviewRoute
  '/org/$org/idea-management/priority-frameworks': typeof appOrgOrgIdeaManagementPriorityFrameworksRoute
  '/published/v1/swimlane/$linkId': typeof unauthenticatedPublishedV1SwimlaneLinkIdRoute
  '/published/v1/timeline/$linkId': typeof unauthenticatedPublishedV1TimelineLinkIdRoute
  '/org/$org/all-items': typeof appOrgOrgAllItemsIndexRoute
  '/org/$org/idea-management': typeof appOrgOrgIdeaManagementIndexRoute
  '/org/$org/nango-playground': typeof appOrgOrgNangoPlaygroundIndexRoute
  '/org/$org/notifications': typeof appOrgOrgNotificationsIndexRoute
  '/org/$org/objectives': typeof appOrgOrgObjectivesIndexRoute
  '/org/$org/settings': typeof appOrgOrgSettingsIndexRoute
  '/org/$org/visualizations': typeof appOrgOrgVisualizationsIndexRoute
  '/organizations/invites/error': typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
  '/org/$org/settings/notifications/slack_app_health': typeof appOrgOrgSettingsNotificationsSlack_app_healthRoute
  '/org/$org/settings/oauth-clients/$id': typeof appOrgOrgSettingsOauthClientsIdRoute
  '/org/$org/idea-management/customers': typeof appOrgOrgIdeaManagementCustomersIndexRoute
  '/org/$org/idea-management/ideas': typeof appOrgOrgIdeaManagementIdeasIndexRoute
  '/org/$org/idea-management/inbox': typeof appOrgOrgIdeaManagementInboxIndexRoute
  '/org/$org/idea-management/portals': typeof appOrgOrgIdeaManagementPortalsIndexRoute
  '/org/$org/idea-management/product-areas': typeof appOrgOrgIdeaManagementProductAreasIndexRoute
  '/org/$org/loop/$loopId': typeof appOrgOrgLoopLoopIdIndexRoute
  '/org/$org/settings/audit': typeof appOrgOrgSettingsAuditIndexRoute
  '/org/$org/settings/capacity': typeof appOrgOrgSettingsCapacityIndexRoute
  '/org/$org/settings/connections': typeof appOrgOrgSettingsConnectionsIndexRoute
  '/org/$org/settings/custom-fields': typeof appOrgOrgSettingsCustomFieldsIndexRoute
  '/org/$org/settings/custom-item-status': typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  '/org/$org/settings/domains': typeof appOrgOrgSettingsDomainsIndexRoute
  '/org/$org/settings/effort-estimation': typeof appOrgOrgSettingsEffortEstimationIndexRoute
  '/org/$org/settings/item-types': typeof appOrgOrgSettingsItemTypesIndexRoute
  '/org/$org/settings/location': typeof appOrgOrgSettingsLocationIndexRoute
  '/org/$org/settings/notifications': typeof appOrgOrgSettingsNotificationsIndexRoute
  '/org/$org/settings/oauth-clients': typeof appOrgOrgSettingsOauthClientsIndexRoute
  '/org/$org/settings/organization': typeof appOrgOrgSettingsOrganizationIndexRoute
  '/org/$org/settings/people': typeof appOrgOrgSettingsPeopleIndexRoute
  '/org/$org/settings/roles': typeof appOrgOrgSettingsRolesIndexRoute
  '/org/$org/settings/skills': typeof appOrgOrgSettingsSkillsIndexRoute
  '/org/$org/settings/subscriptions': typeof appOrgOrgSettingsSubscriptionsIndexRoute
  '/org/$org/settings/teams': typeof appOrgOrgSettingsTeamsIndexRoute
  '/org/$org/settings/user-management': typeof appOrgOrgSettingsUserManagementIndexRoute
  '/org/$org/settings/work-integrations': typeof appOrgOrgSettingsWorkIntegrationsIndexRoute
  '/org/$org/loop/$loopId/insights/$insightId': typeof appOrgOrgLoopLoopIdInsightsInsightIdRouteRoute
  '/org/$org/idea-management/ideas/all': typeof appOrgOrgIdeaManagementIdeasAllIndexRoute
  '/org/$org/idea-management/ideas/completed': typeof appOrgOrgIdeaManagementIdeasCompletedIndexRoute
  '/org/$org/idea-management/ideas/create': typeof appOrgOrgIdeaManagementIdeasCreateIndexRoute
  '/org/$org/idea-management/ideas/view': typeof appOrgOrgIdeaManagementIdeasViewIndexRoute
  '/org/$org/idea-management/portals/$portalId': typeof appOrgOrgIdeaManagementPortalsPortalIdIndexRoute
  '/org/$org/idea-management/portals/create': typeof appOrgOrgIdeaManagementPortalsCreateIndexRoute
  '/org/$org/idea-management/product-areas/$productAreaId': typeof appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute
  '/org/$org/idea-management/product-areas/create': typeof appOrgOrgIdeaManagementProductAreasCreateIndexRoute
  '/org/$org/loop/$loopId/dashboard': typeof appOrgOrgLoopLoopIdDashboardIndexRoute
  '/org/$org/loop/$loopId/insights': typeof appOrgOrgLoopLoopIdInsightsIndexRoute
  '/org/$org/loop/$loopId/integrations': typeof appOrgOrgLoopLoopIdIntegrationsIndexRoute
  '/org/$org/loop/$loopId/overview': typeof appOrgOrgLoopLoopIdOverviewIndexRoute
  '/org/$org/loop/$loopId/planner': typeof appOrgOrgLoopLoopIdPlannerIndexRoute
  '/org/$org/loop/$loopId/portfolio': typeof appOrgOrgLoopLoopIdPortfolioIndexRoute
  '/org/$org/loop/$loopId/teams': typeof appOrgOrgLoopLoopIdTeamsIndexRoute
  '/org/$org/loop/$loopId/visualizations': typeof appOrgOrgLoopLoopIdVisualizationsIndexRoute
  '/org/$org/settings/notifications/subscriptions': typeof appOrgOrgSettingsNotificationsSubscriptionsIndexRoute
  '/org/$org/settings/user-management/invites': typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
  '/org/$org/settings/user-management/users': typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  '/org/$org/settings/work-integrations/$integrationId': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute
  '/org/$org/idea-management/ideas/view/$viewId': typeof appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute
  '/org/$org/idea-management/portals/$portalId/$formId': typeof appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute
  '/org/$org/loop/$loopId/dashboard/deliverables': typeof appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute
  '/org/$org/loop/$loopId/planner/sandbox': typeof appOrgOrgLoopLoopIdPlannerSandboxIndexRoute
  '/org/$org/loop/$loopId/visualizations/main': typeof appOrgOrgLoopLoopIdVisualizationsMainIndexRoute
  '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId': typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  '/org/$org/settings/capacity/workload-scheme/$workloadSchemeId': typeof appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute
  '/org/$org/settings/notifications/subscriptions/idea-manager': typeof appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute
  '/org/$org/settings/teams/team/$teamId': typeof appOrgOrgSettingsTeamsTeamTeamIdIndexRoute
  '/org/$org/settings/user-management/users/$userId': typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
  '/org/$org/settings/work-integrations/$integrationId/issues': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute
  '/org/$org/settings/work-integrations/$integrationId/logs': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute
  '/org/$org/loop/$loopId/planner/sandbox/table': typeof appOrgOrgLoopLoopIdPlannerSandboxTableIndexRoute
  '/org/$org/loop/$loopId/planner/sandbox/timeline': typeof appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute
  '/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId': typeof appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/swimlane': typeof appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/table': typeof appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/timeline': typeof appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/table': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(app)': typeof appRouteRouteWithChildren
  '/(unauthenticated)/signup': typeof unauthenticatedSignupRoute
  '/(unauthenticated)/terms': typeof unauthenticatedTermsRoute
  '/(app)/': typeof appIndexRoute
  '/(app)/org/$org': typeof appOrgOrgRouteRouteWithChildren
  '/(unauthenticated)/organizations/invites': typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  '/(unauthenticated)/link-identity/callback': typeof unauthenticatedLinkIdentityCallbackRoute
  '/(unauthenticated)/organizations/start': typeof unauthenticatedOrganizationsStartRoute
  '/(app)/invites/': typeof appInvitesIndexRoute
  '/(app)/org/': typeof appOrgIndexRoute
  '/(app)/profile/': typeof appProfileIndexRoute
  '/(unauthenticated)/link-identity/': typeof unauthenticatedLinkIdentityIndexRoute
  '/(unauthenticated)/organization-selector/': typeof unauthenticatedOrganizationSelectorIndexRoute
  '/(app)/org/$org/idea-management': typeof appOrgOrgIdeaManagementRouteRouteWithChildren
  '/(app)/org/$org/loop': typeof appOrgOrgLoopRouteRouteWithChildren
  '/(app)/org/$org/settings': typeof appOrgOrgSettingsRouteRouteWithChildren
  '/(app)/integrations/jira/callback': typeof appIntegrationsJiraCallbackRoute
  '/(app)/integrations/slack/callback': typeof appIntegrationsSlackCallbackRoute
  '/(app)/org-id/$orgId/$': typeof appOrgIdOrgIdSplatRoute
  '/(unauthenticated)/organizations/invites/accept': typeof unauthenticatedOrganizationsInvitesAcceptRoute
  '/(app)/org/$org/': typeof appOrgOrgIndexRoute
  '/(app)/org/$org/idea-management/inbox': typeof appOrgOrgIdeaManagementInboxRouteRouteWithChildren
  '/(app)/org/$org/idea-management/portals': typeof appOrgOrgIdeaManagementPortalsRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId': typeof appOrgOrgLoopLoopIdRouteRouteWithChildren
  '/(app)/org/$org/settings/capacity': typeof appOrgOrgSettingsCapacityRouteRouteWithChildren
  '/(app)/org/$org/settings/connections': typeof appOrgOrgSettingsConnectionsRouteRouteWithChildren
  '/(app)/org/$org/settings/domains': typeof appOrgOrgSettingsDomainsRouteRouteWithChildren
  '/(app)/org/$org/settings/location': typeof appOrgOrgSettingsLocationRouteRouteWithChildren
  '/(app)/org/$org/settings/oauth-clients': typeof appOrgOrgSettingsOauthClientsRouteRouteWithChildren
  '/(app)/org/$org/settings/organization': typeof appOrgOrgSettingsOrganizationRouteRouteWithChildren
  '/(app)/org/$org/settings/people': typeof appOrgOrgSettingsPeopleRouteRouteWithChildren
  '/(app)/org/$org/settings/roles': typeof appOrgOrgSettingsRolesRouteRouteWithChildren
  '/(app)/org/$org/settings/skills': typeof appOrgOrgSettingsSkillsRouteRouteWithChildren
  '/(app)/org/$org/settings/subscriptions': typeof appOrgOrgSettingsSubscriptionsRouteRouteWithChildren
  '/(app)/org/$org/settings/teams': typeof appOrgOrgSettingsTeamsRouteRouteWithChildren
  '/(app)/org/$org/settings/user-management': typeof appOrgOrgSettingsUserManagementRouteRouteWithChildren
  '/(app)/org/$org/idea-management/component-gallery': typeof appOrgOrgIdeaManagementComponentGalleryRoute
  '/(app)/org/$org/idea-management/custom-fields': typeof appOrgOrgIdeaManagementCustomFieldsRoute
  '/(app)/org/$org/idea-management/overview': typeof appOrgOrgIdeaManagementOverviewRoute
  '/(app)/org/$org/idea-management/priority-frameworks': typeof appOrgOrgIdeaManagementPriorityFrameworksRoute
  '/(unauthenticated)/published/v1/swimlane/$linkId': typeof unauthenticatedPublishedV1SwimlaneLinkIdRoute
  '/(unauthenticated)/published/v1/timeline/$linkId': typeof unauthenticatedPublishedV1TimelineLinkIdRoute
  '/(app)/org/$org/all-items/': typeof appOrgOrgAllItemsIndexRoute
  '/(app)/org/$org/idea-management/': typeof appOrgOrgIdeaManagementIndexRoute
  '/(app)/org/$org/nango-playground/': typeof appOrgOrgNangoPlaygroundIndexRoute
  '/(app)/org/$org/notifications/': typeof appOrgOrgNotificationsIndexRoute
  '/(app)/org/$org/objectives/': typeof appOrgOrgObjectivesIndexRoute
  '/(app)/org/$org/settings/': typeof appOrgOrgSettingsIndexRoute
  '/(app)/org/$org/visualizations/': typeof appOrgOrgVisualizationsIndexRoute
  '/(unauthenticated)/organizations/invites/error/': typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
  '/(app)/org/$org/loop/$loopId/dashboard': typeof appOrgOrgLoopLoopIdDashboardRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/insights': typeof appOrgOrgLoopLoopIdInsightsRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/planner': typeof appOrgOrgLoopLoopIdPlannerRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/portfolio': typeof appOrgOrgLoopLoopIdPortfolioRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/teams': typeof appOrgOrgLoopLoopIdTeamsRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/visualizations': typeof appOrgOrgLoopLoopIdVisualizationsRouteRouteWithChildren
  '/(app)/org/$org/settings/notifications/subscriptions': typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRouteWithChildren
  '/(app)/org/$org/settings/user-management/users': typeof appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren
  '/(app)/org/$org/settings/work-integrations/$integrationId': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteWithChildren
  '/(app)/org/$org/settings/notifications/slack_app_health': typeof appOrgOrgSettingsNotificationsSlack_app_healthRoute
  '/(app)/org/$org/settings/oauth-clients/$id': typeof appOrgOrgSettingsOauthClientsIdRoute
  '/(app)/org/$org/idea-management/customers/': typeof appOrgOrgIdeaManagementCustomersIndexRoute
  '/(app)/org/$org/idea-management/ideas/': typeof appOrgOrgIdeaManagementIdeasIndexRoute
  '/(app)/org/$org/idea-management/inbox/': typeof appOrgOrgIdeaManagementInboxIndexRoute
  '/(app)/org/$org/idea-management/portals/': typeof appOrgOrgIdeaManagementPortalsIndexRoute
  '/(app)/org/$org/idea-management/product-areas/': typeof appOrgOrgIdeaManagementProductAreasIndexRoute
  '/(app)/org/$org/loop/$loopId/': typeof appOrgOrgLoopLoopIdIndexRoute
  '/(app)/org/$org/settings/audit/': typeof appOrgOrgSettingsAuditIndexRoute
  '/(app)/org/$org/settings/capacity/': typeof appOrgOrgSettingsCapacityIndexRoute
  '/(app)/org/$org/settings/connections/': typeof appOrgOrgSettingsConnectionsIndexRoute
  '/(app)/org/$org/settings/custom-fields/': typeof appOrgOrgSettingsCustomFieldsIndexRoute
  '/(app)/org/$org/settings/custom-item-status/': typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  '/(app)/org/$org/settings/domains/': typeof appOrgOrgSettingsDomainsIndexRoute
  '/(app)/org/$org/settings/effort-estimation/': typeof appOrgOrgSettingsEffortEstimationIndexRoute
  '/(app)/org/$org/settings/item-types/': typeof appOrgOrgSettingsItemTypesIndexRoute
  '/(app)/org/$org/settings/location/': typeof appOrgOrgSettingsLocationIndexRoute
  '/(app)/org/$org/settings/notifications/': typeof appOrgOrgSettingsNotificationsIndexRoute
  '/(app)/org/$org/settings/oauth-clients/': typeof appOrgOrgSettingsOauthClientsIndexRoute
  '/(app)/org/$org/settings/organization/': typeof appOrgOrgSettingsOrganizationIndexRoute
  '/(app)/org/$org/settings/people/': typeof appOrgOrgSettingsPeopleIndexRoute
  '/(app)/org/$org/settings/roles/': typeof appOrgOrgSettingsRolesIndexRoute
  '/(app)/org/$org/settings/skills/': typeof appOrgOrgSettingsSkillsIndexRoute
  '/(app)/org/$org/settings/subscriptions/': typeof appOrgOrgSettingsSubscriptionsIndexRoute
  '/(app)/org/$org/settings/teams/': typeof appOrgOrgSettingsTeamsIndexRoute
  '/(app)/org/$org/settings/user-management/': typeof appOrgOrgSettingsUserManagementIndexRoute
  '/(app)/org/$org/settings/work-integrations/': typeof appOrgOrgSettingsWorkIntegrationsIndexRoute
  '/(app)/org/$org/loop/$loopId/insights/$insightId': typeof appOrgOrgLoopLoopIdInsightsInsightIdRouteRoute
  '/(app)/org/$org/loop/$loopId/planner/sandbox': typeof appOrgOrgLoopLoopIdPlannerSandboxRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/visualizations/main': typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRouteWithChildren
  '/(app)/org/$org/settings/teams/team/$teamId': typeof appOrgOrgSettingsTeamsTeamTeamIdRouteRouteWithChildren
  '/(app)/org/$org/idea-management/ideas/all/': typeof appOrgOrgIdeaManagementIdeasAllIndexRoute
  '/(app)/org/$org/idea-management/ideas/completed/': typeof appOrgOrgIdeaManagementIdeasCompletedIndexRoute
  '/(app)/org/$org/idea-management/ideas/create/': typeof appOrgOrgIdeaManagementIdeasCreateIndexRoute
  '/(app)/org/$org/idea-management/ideas/view/': typeof appOrgOrgIdeaManagementIdeasViewIndexRoute
  '/(app)/org/$org/idea-management/portals/$portalId/': typeof appOrgOrgIdeaManagementPortalsPortalIdIndexRoute
  '/(app)/org/$org/idea-management/portals/create/': typeof appOrgOrgIdeaManagementPortalsCreateIndexRoute
  '/(app)/org/$org/idea-management/product-areas/$productAreaId/': typeof appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute
  '/(app)/org/$org/idea-management/product-areas/create/': typeof appOrgOrgIdeaManagementProductAreasCreateIndexRoute
  '/(app)/org/$org/loop/$loopId/dashboard/': typeof appOrgOrgLoopLoopIdDashboardIndexRoute
  '/(app)/org/$org/loop/$loopId/insights/': typeof appOrgOrgLoopLoopIdInsightsIndexRoute
  '/(app)/org/$org/loop/$loopId/integrations/': typeof appOrgOrgLoopLoopIdIntegrationsIndexRoute
  '/(app)/org/$org/loop/$loopId/overview/': typeof appOrgOrgLoopLoopIdOverviewIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/': typeof appOrgOrgLoopLoopIdPlannerIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/': typeof appOrgOrgLoopLoopIdPortfolioIndexRoute
  '/(app)/org/$org/loop/$loopId/teams/': typeof appOrgOrgLoopLoopIdTeamsIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/': typeof appOrgOrgLoopLoopIdVisualizationsIndexRoute
  '/(app)/org/$org/settings/notifications/subscriptions/': typeof appOrgOrgSettingsNotificationsSubscriptionsIndexRoute
  '/(app)/org/$org/settings/user-management/invites/': typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
  '/(app)/org/$org/settings/user-management/users/': typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  '/(app)/org/$org/settings/work-integrations/$integrationId/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteWithChildren
  '/(app)/org/$org/idea-management/ideas/view/$viewId/': typeof appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute
  '/(app)/org/$org/idea-management/portals/$portalId/$formId/': typeof appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute
  '/(app)/org/$org/loop/$loopId/dashboard/deliverables/': typeof appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/sandbox/': typeof appOrgOrgLoopLoopIdPlannerSandboxIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/main/': typeof appOrgOrgLoopLoopIdVisualizationsMainIndexRoute
  '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/': typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  '/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/': typeof appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute
  '/(app)/org/$org/settings/notifications/subscriptions/idea-manager/': typeof appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute
  '/(app)/org/$org/settings/teams/team/$teamId/': typeof appOrgOrgSettingsTeamsTeamTeamIdIndexRoute
  '/(app)/org/$org/settings/user-management/users/$userId/': typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
  '/(app)/org/$org/settings/work-integrations/$integrationId/issues/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute
  '/(app)/org/$org/settings/work-integrations/$integrationId/logs/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/sandbox/table/': typeof appOrgOrgLoopLoopIdPlannerSandboxTableIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/sandbox/timeline/': typeof appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId/': typeof appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/': typeof appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/main/table/': typeof appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/main/timeline/': typeof appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute
  '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/table/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/signup'
    | '/terms'
    | '/'
    | '/org/$org'
    | '/organizations/invites'
    | '/link-identity/callback'
    | '/organizations/start'
    | '/invites/'
    | '/org/'
    | '/profile/'
    | '/link-identity/'
    | '/organization-selector/'
    | '/org/$org/idea-management'
    | '/org/$org/loop'
    | '/org/$org/settings'
    | '/integrations/jira/callback'
    | '/integrations/slack/callback'
    | '/org-id/$orgId/$'
    | '/organizations/invites/accept'
    | '/org/$org/'
    | '/org/$org/idea-management/inbox'
    | '/org/$org/idea-management/portals'
    | '/org/$org/loop/$loopId'
    | '/org/$org/settings/capacity'
    | '/org/$org/settings/connections'
    | '/org/$org/settings/domains'
    | '/org/$org/settings/location'
    | '/org/$org/settings/oauth-clients'
    | '/org/$org/settings/organization'
    | '/org/$org/settings/people'
    | '/org/$org/settings/roles'
    | '/org/$org/settings/skills'
    | '/org/$org/settings/subscriptions'
    | '/org/$org/settings/teams'
    | '/org/$org/settings/user-management'
    | '/org/$org/idea-management/component-gallery'
    | '/org/$org/idea-management/custom-fields'
    | '/org/$org/idea-management/overview'
    | '/org/$org/idea-management/priority-frameworks'
    | '/published/v1/swimlane/$linkId'
    | '/published/v1/timeline/$linkId'
    | '/org/$org/all-items/'
    | '/org/$org/idea-management/'
    | '/org/$org/nango-playground/'
    | '/org/$org/notifications/'
    | '/org/$org/objectives/'
    | '/org/$org/settings/'
    | '/org/$org/visualizations/'
    | '/organizations/invites/error/'
    | '/org/$org/loop/$loopId/dashboard'
    | '/org/$org/loop/$loopId/insights'
    | '/org/$org/loop/$loopId/planner'
    | '/org/$org/loop/$loopId/portfolio'
    | '/org/$org/loop/$loopId/teams'
    | '/org/$org/loop/$loopId/visualizations'
    | '/org/$org/settings/notifications/subscriptions'
    | '/org/$org/settings/user-management/users'
    | '/org/$org/settings/work-integrations/$integrationId'
    | '/org/$org/settings/notifications/slack_app_health'
    | '/org/$org/settings/oauth-clients/$id'
    | '/org/$org/idea-management/customers/'
    | '/org/$org/idea-management/ideas/'
    | '/org/$org/idea-management/inbox/'
    | '/org/$org/idea-management/portals/'
    | '/org/$org/idea-management/product-areas/'
    | '/org/$org/loop/$loopId/'
    | '/org/$org/settings/audit/'
    | '/org/$org/settings/capacity/'
    | '/org/$org/settings/connections/'
    | '/org/$org/settings/custom-fields/'
    | '/org/$org/settings/custom-item-status/'
    | '/org/$org/settings/domains/'
    | '/org/$org/settings/effort-estimation/'
    | '/org/$org/settings/item-types/'
    | '/org/$org/settings/location/'
    | '/org/$org/settings/notifications/'
    | '/org/$org/settings/oauth-clients/'
    | '/org/$org/settings/organization/'
    | '/org/$org/settings/people/'
    | '/org/$org/settings/roles/'
    | '/org/$org/settings/skills/'
    | '/org/$org/settings/subscriptions/'
    | '/org/$org/settings/teams/'
    | '/org/$org/settings/user-management/'
    | '/org/$org/settings/work-integrations/'
    | '/org/$org/loop/$loopId/insights/$insightId'
    | '/org/$org/loop/$loopId/planner/sandbox'
    | '/org/$org/loop/$loopId/visualizations/main'
    | '/org/$org/settings/teams/team/$teamId'
    | '/org/$org/idea-management/ideas/all/'
    | '/org/$org/idea-management/ideas/completed/'
    | '/org/$org/idea-management/ideas/create/'
    | '/org/$org/idea-management/ideas/view/'
    | '/org/$org/idea-management/portals/$portalId/'
    | '/org/$org/idea-management/portals/create/'
    | '/org/$org/idea-management/product-areas/$productAreaId/'
    | '/org/$org/idea-management/product-areas/create/'
    | '/org/$org/loop/$loopId/dashboard/'
    | '/org/$org/loop/$loopId/insights/'
    | '/org/$org/loop/$loopId/integrations/'
    | '/org/$org/loop/$loopId/overview/'
    | '/org/$org/loop/$loopId/planner/'
    | '/org/$org/loop/$loopId/portfolio/'
    | '/org/$org/loop/$loopId/teams/'
    | '/org/$org/loop/$loopId/visualizations/'
    | '/org/$org/settings/notifications/subscriptions/'
    | '/org/$org/settings/user-management/invites/'
    | '/org/$org/settings/user-management/users/'
    | '/org/$org/settings/work-integrations/$integrationId/'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId'
    | '/org/$org/idea-management/ideas/view/$viewId/'
    | '/org/$org/idea-management/portals/$portalId/$formId/'
    | '/org/$org/loop/$loopId/dashboard/deliverables/'
    | '/org/$org/loop/$loopId/planner/sandbox/'
    | '/org/$org/loop/$loopId/visualizations/main/'
    | '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/'
    | '/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/'
    | '/org/$org/settings/notifications/subscriptions/idea-manager/'
    | '/org/$org/settings/teams/team/$teamId/'
    | '/org/$org/settings/user-management/users/$userId/'
    | '/org/$org/settings/work-integrations/$integrationId/issues/'
    | '/org/$org/settings/work-integrations/$integrationId/logs/'
    | '/org/$org/loop/$loopId/planner/sandbox/table/'
    | '/org/$org/loop/$loopId/planner/sandbox/timeline/'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/'
    | '/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId/'
    | '/org/$org/loop/$loopId/visualizations/main/swimlane/'
    | '/org/$org/loop/$loopId/visualizations/main/table/'
    | '/org/$org/loop/$loopId/visualizations/main/timeline/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/table/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signup'
    | '/terms'
    | '/'
    | '/organizations/invites'
    | '/link-identity/callback'
    | '/organizations/start'
    | '/invites'
    | '/org'
    | '/profile'
    | '/link-identity'
    | '/organization-selector'
    | '/org/$org/loop'
    | '/integrations/jira/callback'
    | '/integrations/slack/callback'
    | '/org-id/$orgId/$'
    | '/organizations/invites/accept'
    | '/org/$org'
    | '/org/$org/idea-management/component-gallery'
    | '/org/$org/idea-management/custom-fields'
    | '/org/$org/idea-management/overview'
    | '/org/$org/idea-management/priority-frameworks'
    | '/published/v1/swimlane/$linkId'
    | '/published/v1/timeline/$linkId'
    | '/org/$org/all-items'
    | '/org/$org/idea-management'
    | '/org/$org/nango-playground'
    | '/org/$org/notifications'
    | '/org/$org/objectives'
    | '/org/$org/settings'
    | '/org/$org/visualizations'
    | '/organizations/invites/error'
    | '/org/$org/settings/notifications/slack_app_health'
    | '/org/$org/settings/oauth-clients/$id'
    | '/org/$org/idea-management/customers'
    | '/org/$org/idea-management/ideas'
    | '/org/$org/idea-management/inbox'
    | '/org/$org/idea-management/portals'
    | '/org/$org/idea-management/product-areas'
    | '/org/$org/loop/$loopId'
    | '/org/$org/settings/audit'
    | '/org/$org/settings/capacity'
    | '/org/$org/settings/connections'
    | '/org/$org/settings/custom-fields'
    | '/org/$org/settings/custom-item-status'
    | '/org/$org/settings/domains'
    | '/org/$org/settings/effort-estimation'
    | '/org/$org/settings/item-types'
    | '/org/$org/settings/location'
    | '/org/$org/settings/notifications'
    | '/org/$org/settings/oauth-clients'
    | '/org/$org/settings/organization'
    | '/org/$org/settings/people'
    | '/org/$org/settings/roles'
    | '/org/$org/settings/skills'
    | '/org/$org/settings/subscriptions'
    | '/org/$org/settings/teams'
    | '/org/$org/settings/user-management'
    | '/org/$org/settings/work-integrations'
    | '/org/$org/loop/$loopId/insights/$insightId'
    | '/org/$org/idea-management/ideas/all'
    | '/org/$org/idea-management/ideas/completed'
    | '/org/$org/idea-management/ideas/create'
    | '/org/$org/idea-management/ideas/view'
    | '/org/$org/idea-management/portals/$portalId'
    | '/org/$org/idea-management/portals/create'
    | '/org/$org/idea-management/product-areas/$productAreaId'
    | '/org/$org/idea-management/product-areas/create'
    | '/org/$org/loop/$loopId/dashboard'
    | '/org/$org/loop/$loopId/insights'
    | '/org/$org/loop/$loopId/integrations'
    | '/org/$org/loop/$loopId/overview'
    | '/org/$org/loop/$loopId/planner'
    | '/org/$org/loop/$loopId/portfolio'
    | '/org/$org/loop/$loopId/teams'
    | '/org/$org/loop/$loopId/visualizations'
    | '/org/$org/settings/notifications/subscriptions'
    | '/org/$org/settings/user-management/invites'
    | '/org/$org/settings/user-management/users'
    | '/org/$org/settings/work-integrations/$integrationId'
    | '/org/$org/idea-management/ideas/view/$viewId'
    | '/org/$org/idea-management/portals/$portalId/$formId'
    | '/org/$org/loop/$loopId/dashboard/deliverables'
    | '/org/$org/loop/$loopId/planner/sandbox'
    | '/org/$org/loop/$loopId/visualizations/main'
    | '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId'
    | '/org/$org/settings/capacity/workload-scheme/$workloadSchemeId'
    | '/org/$org/settings/notifications/subscriptions/idea-manager'
    | '/org/$org/settings/teams/team/$teamId'
    | '/org/$org/settings/user-management/users/$userId'
    | '/org/$org/settings/work-integrations/$integrationId/issues'
    | '/org/$org/settings/work-integrations/$integrationId/logs'
    | '/org/$org/loop/$loopId/planner/sandbox/table'
    | '/org/$org/loop/$loopId/planner/sandbox/timeline'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId'
    | '/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId'
    | '/org/$org/loop/$loopId/visualizations/main/swimlane'
    | '/org/$org/loop/$loopId/visualizations/main/table'
    | '/org/$org/loop/$loopId/visualizations/main/timeline'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/table'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId'
  id:
    | '__root__'
    | '/(app)'
    | '/(unauthenticated)/signup'
    | '/(unauthenticated)/terms'
    | '/(app)/'
    | '/(app)/org/$org'
    | '/(unauthenticated)/organizations/invites'
    | '/(unauthenticated)/link-identity/callback'
    | '/(unauthenticated)/organizations/start'
    | '/(app)/invites/'
    | '/(app)/org/'
    | '/(app)/profile/'
    | '/(unauthenticated)/link-identity/'
    | '/(unauthenticated)/organization-selector/'
    | '/(app)/org/$org/idea-management'
    | '/(app)/org/$org/loop'
    | '/(app)/org/$org/settings'
    | '/(app)/integrations/jira/callback'
    | '/(app)/integrations/slack/callback'
    | '/(app)/org-id/$orgId/$'
    | '/(unauthenticated)/organizations/invites/accept'
    | '/(app)/org/$org/'
    | '/(app)/org/$org/idea-management/inbox'
    | '/(app)/org/$org/idea-management/portals'
    | '/(app)/org/$org/loop/$loopId'
    | '/(app)/org/$org/settings/capacity'
    | '/(app)/org/$org/settings/connections'
    | '/(app)/org/$org/settings/domains'
    | '/(app)/org/$org/settings/location'
    | '/(app)/org/$org/settings/oauth-clients'
    | '/(app)/org/$org/settings/organization'
    | '/(app)/org/$org/settings/people'
    | '/(app)/org/$org/settings/roles'
    | '/(app)/org/$org/settings/skills'
    | '/(app)/org/$org/settings/subscriptions'
    | '/(app)/org/$org/settings/teams'
    | '/(app)/org/$org/settings/user-management'
    | '/(app)/org/$org/idea-management/component-gallery'
    | '/(app)/org/$org/idea-management/custom-fields'
    | '/(app)/org/$org/idea-management/overview'
    | '/(app)/org/$org/idea-management/priority-frameworks'
    | '/(unauthenticated)/published/v1/swimlane/$linkId'
    | '/(unauthenticated)/published/v1/timeline/$linkId'
    | '/(app)/org/$org/all-items/'
    | '/(app)/org/$org/idea-management/'
    | '/(app)/org/$org/nango-playground/'
    | '/(app)/org/$org/notifications/'
    | '/(app)/org/$org/objectives/'
    | '/(app)/org/$org/settings/'
    | '/(app)/org/$org/visualizations/'
    | '/(unauthenticated)/organizations/invites/error/'
    | '/(app)/org/$org/loop/$loopId/dashboard'
    | '/(app)/org/$org/loop/$loopId/insights'
    | '/(app)/org/$org/loop/$loopId/planner'
    | '/(app)/org/$org/loop/$loopId/portfolio'
    | '/(app)/org/$org/loop/$loopId/teams'
    | '/(app)/org/$org/loop/$loopId/visualizations'
    | '/(app)/org/$org/settings/notifications/subscriptions'
    | '/(app)/org/$org/settings/user-management/users'
    | '/(app)/org/$org/settings/work-integrations/$integrationId'
    | '/(app)/org/$org/settings/notifications/slack_app_health'
    | '/(app)/org/$org/settings/oauth-clients/$id'
    | '/(app)/org/$org/idea-management/customers/'
    | '/(app)/org/$org/idea-management/ideas/'
    | '/(app)/org/$org/idea-management/inbox/'
    | '/(app)/org/$org/idea-management/portals/'
    | '/(app)/org/$org/idea-management/product-areas/'
    | '/(app)/org/$org/loop/$loopId/'
    | '/(app)/org/$org/settings/audit/'
    | '/(app)/org/$org/settings/capacity/'
    | '/(app)/org/$org/settings/connections/'
    | '/(app)/org/$org/settings/custom-fields/'
    | '/(app)/org/$org/settings/custom-item-status/'
    | '/(app)/org/$org/settings/domains/'
    | '/(app)/org/$org/settings/effort-estimation/'
    | '/(app)/org/$org/settings/item-types/'
    | '/(app)/org/$org/settings/location/'
    | '/(app)/org/$org/settings/notifications/'
    | '/(app)/org/$org/settings/oauth-clients/'
    | '/(app)/org/$org/settings/organization/'
    | '/(app)/org/$org/settings/people/'
    | '/(app)/org/$org/settings/roles/'
    | '/(app)/org/$org/settings/skills/'
    | '/(app)/org/$org/settings/subscriptions/'
    | '/(app)/org/$org/settings/teams/'
    | '/(app)/org/$org/settings/user-management/'
    | '/(app)/org/$org/settings/work-integrations/'
    | '/(app)/org/$org/loop/$loopId/insights/$insightId'
    | '/(app)/org/$org/loop/$loopId/planner/sandbox'
    | '/(app)/org/$org/loop/$loopId/visualizations/main'
    | '/(app)/org/$org/settings/teams/team/$teamId'
    | '/(app)/org/$org/idea-management/ideas/all/'
    | '/(app)/org/$org/idea-management/ideas/completed/'
    | '/(app)/org/$org/idea-management/ideas/create/'
    | '/(app)/org/$org/idea-management/ideas/view/'
    | '/(app)/org/$org/idea-management/portals/$portalId/'
    | '/(app)/org/$org/idea-management/portals/create/'
    | '/(app)/org/$org/idea-management/product-areas/$productAreaId/'
    | '/(app)/org/$org/idea-management/product-areas/create/'
    | '/(app)/org/$org/loop/$loopId/dashboard/'
    | '/(app)/org/$org/loop/$loopId/insights/'
    | '/(app)/org/$org/loop/$loopId/integrations/'
    | '/(app)/org/$org/loop/$loopId/overview/'
    | '/(app)/org/$org/loop/$loopId/planner/'
    | '/(app)/org/$org/loop/$loopId/portfolio/'
    | '/(app)/org/$org/loop/$loopId/teams/'
    | '/(app)/org/$org/loop/$loopId/visualizations/'
    | '/(app)/org/$org/settings/notifications/subscriptions/'
    | '/(app)/org/$org/settings/user-management/invites/'
    | '/(app)/org/$org/settings/user-management/users/'
    | '/(app)/org/$org/settings/work-integrations/$integrationId/'
    | '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId'
    | '/(app)/org/$org/idea-management/ideas/view/$viewId/'
    | '/(app)/org/$org/idea-management/portals/$portalId/$formId/'
    | '/(app)/org/$org/loop/$loopId/dashboard/deliverables/'
    | '/(app)/org/$org/loop/$loopId/planner/sandbox/'
    | '/(app)/org/$org/loop/$loopId/visualizations/main/'
    | '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/'
    | '/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/'
    | '/(app)/org/$org/settings/notifications/subscriptions/idea-manager/'
    | '/(app)/org/$org/settings/teams/team/$teamId/'
    | '/(app)/org/$org/settings/user-management/users/$userId/'
    | '/(app)/org/$org/settings/work-integrations/$integrationId/issues/'
    | '/(app)/org/$org/settings/work-integrations/$integrationId/logs/'
    | '/(app)/org/$org/loop/$loopId/planner/sandbox/table/'
    | '/(app)/org/$org/loop/$loopId/planner/sandbox/timeline/'
    | '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/'
    | '/(app)/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId/'
    | '/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/'
    | '/(app)/org/$org/loop/$loopId/visualizations/main/table/'
    | '/(app)/org/$org/loop/$loopId/visualizations/main/timeline/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/'
    | '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
    | '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
    | '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
    | '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
    | '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/'
    | '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/table/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  appRouteRoute: typeof appRouteRouteWithChildren
  unauthenticatedSignupRoute: typeof unauthenticatedSignupRoute
  unauthenticatedTermsRoute: typeof unauthenticatedTermsRoute
  unauthenticatedOrganizationsInvitesRouteRoute: typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  unauthenticatedLinkIdentityCallbackRoute: typeof unauthenticatedLinkIdentityCallbackRoute
  unauthenticatedOrganizationsStartRoute: typeof unauthenticatedOrganizationsStartRoute
  unauthenticatedLinkIdentityIndexRoute: typeof unauthenticatedLinkIdentityIndexRoute
  unauthenticatedOrganizationSelectorIndexRoute: typeof unauthenticatedOrganizationSelectorIndexRoute
  unauthenticatedPublishedV1SwimlaneLinkIdRoute: typeof unauthenticatedPublishedV1SwimlaneLinkIdRoute
  unauthenticatedPublishedV1TimelineLinkIdRoute: typeof unauthenticatedPublishedV1TimelineLinkIdRoute
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)': {
      id: '/(app)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/': {
      id: '/(app)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(unauthenticated)/terms': {
      id: '/(unauthenticated)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof unauthenticatedTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/signup': {
      id: '/(unauthenticated)/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof unauthenticatedSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/organization-selector/': {
      id: '/(unauthenticated)/organization-selector/'
      path: '/organization-selector'
      fullPath: '/organization-selector/'
      preLoaderRoute: typeof unauthenticatedOrganizationSelectorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/link-identity/': {
      id: '/(unauthenticated)/link-identity/'
      path: '/link-identity'
      fullPath: '/link-identity/'
      preLoaderRoute: typeof unauthenticatedLinkIdentityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/profile/': {
      id: '/(app)/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof appProfileIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/org/': {
      id: '/(app)/org/'
      path: '/org'
      fullPath: '/org/'
      preLoaderRoute: typeof appOrgIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/invites/': {
      id: '/(app)/invites/'
      path: '/invites'
      fullPath: '/invites/'
      preLoaderRoute: typeof appInvitesIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(unauthenticated)/organizations/start': {
      id: '/(unauthenticated)/organizations/start'
      path: '/organizations/start'
      fullPath: '/organizations/start'
      preLoaderRoute: typeof unauthenticatedOrganizationsStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/link-identity/callback': {
      id: '/(unauthenticated)/link-identity/callback'
      path: '/link-identity/callback'
      fullPath: '/link-identity/callback'
      preLoaderRoute: typeof unauthenticatedLinkIdentityCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/organizations/invites': {
      id: '/(unauthenticated)/organizations/invites'
      path: '/organizations/invites'
      fullPath: '/organizations/invites'
      preLoaderRoute: typeof unauthenticatedOrganizationsInvitesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$org': {
      id: '/(app)/org/$org'
      path: '/org/$org'
      fullPath: '/org/$org'
      preLoaderRoute: typeof appOrgOrgRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/org/$org/': {
      id: '/(app)/org/$org/'
      path: '/'
      fullPath: '/org/$org/'
      preLoaderRoute: typeof appOrgOrgIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(unauthenticated)/organizations/invites/accept': {
      id: '/(unauthenticated)/organizations/invites/accept'
      path: '/accept'
      fullPath: '/organizations/invites/accept'
      preLoaderRoute: typeof unauthenticatedOrganizationsInvitesAcceptRouteImport
      parentRoute: typeof unauthenticatedOrganizationsInvitesRouteRoute
    }
    '/(app)/org-id/$orgId/$': {
      id: '/(app)/org-id/$orgId/$'
      path: '/org-id/$orgId/$'
      fullPath: '/org-id/$orgId/$'
      preLoaderRoute: typeof appOrgIdOrgIdSplatRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/integrations/slack/callback': {
      id: '/(app)/integrations/slack/callback'
      path: '/integrations/slack/callback'
      fullPath: '/integrations/slack/callback'
      preLoaderRoute: typeof appIntegrationsSlackCallbackRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/integrations/jira/callback': {
      id: '/(app)/integrations/jira/callback'
      path: '/integrations/jira/callback'
      fullPath: '/integrations/jira/callback'
      preLoaderRoute: typeof appIntegrationsJiraCallbackRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/org/$org/settings': {
      id: '/(app)/org/$org/settings'
      path: '/settings'
      fullPath: '/org/$org/settings'
      preLoaderRoute: typeof appOrgOrgSettingsRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/loop': {
      id: '/(app)/org/$org/loop'
      path: '/loop'
      fullPath: '/org/$org/loop'
      preLoaderRoute: typeof appOrgOrgLoopRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/idea-management': {
      id: '/(app)/org/$org/idea-management'
      path: '/idea-management'
      fullPath: '/org/$org/idea-management'
      preLoaderRoute: typeof appOrgOrgIdeaManagementRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(unauthenticated)/organizations/invites/error/': {
      id: '/(unauthenticated)/organizations/invites/error/'
      path: '/error'
      fullPath: '/organizations/invites/error/'
      preLoaderRoute: typeof unauthenticatedOrganizationsInvitesErrorIndexRouteImport
      parentRoute: typeof unauthenticatedOrganizationsInvitesRouteRoute
    }
    '/(app)/org/$org/visualizations/': {
      id: '/(app)/org/$org/visualizations/'
      path: '/visualizations'
      fullPath: '/org/$org/visualizations/'
      preLoaderRoute: typeof appOrgOrgVisualizationsIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/settings/': {
      id: '/(app)/org/$org/settings/'
      path: '/'
      fullPath: '/org/$org/settings/'
      preLoaderRoute: typeof appOrgOrgSettingsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/objectives/': {
      id: '/(app)/org/$org/objectives/'
      path: '/objectives'
      fullPath: '/org/$org/objectives/'
      preLoaderRoute: typeof appOrgOrgObjectivesIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/notifications/': {
      id: '/(app)/org/$org/notifications/'
      path: '/notifications'
      fullPath: '/org/$org/notifications/'
      preLoaderRoute: typeof appOrgOrgNotificationsIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/nango-playground/': {
      id: '/(app)/org/$org/nango-playground/'
      path: '/nango-playground'
      fullPath: '/org/$org/nango-playground/'
      preLoaderRoute: typeof appOrgOrgNangoPlaygroundIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/idea-management/': {
      id: '/(app)/org/$org/idea-management/'
      path: '/'
      fullPath: '/org/$org/idea-management/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/all-items/': {
      id: '/(app)/org/$org/all-items/'
      path: '/all-items'
      fullPath: '/org/$org/all-items/'
      preLoaderRoute: typeof appOrgOrgAllItemsIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(unauthenticated)/published/v1/timeline/$linkId': {
      id: '/(unauthenticated)/published/v1/timeline/$linkId'
      path: '/published/v1/timeline/$linkId'
      fullPath: '/published/v1/timeline/$linkId'
      preLoaderRoute: typeof unauthenticatedPublishedV1TimelineLinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/published/v1/swimlane/$linkId': {
      id: '/(unauthenticated)/published/v1/swimlane/$linkId'
      path: '/published/v1/swimlane/$linkId'
      fullPath: '/published/v1/swimlane/$linkId'
      preLoaderRoute: typeof unauthenticatedPublishedV1SwimlaneLinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$org/idea-management/priority-frameworks': {
      id: '/(app)/org/$org/idea-management/priority-frameworks'
      path: '/priority-frameworks'
      fullPath: '/org/$org/idea-management/priority-frameworks'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPriorityFrameworksRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/overview': {
      id: '/(app)/org/$org/idea-management/overview'
      path: '/overview'
      fullPath: '/org/$org/idea-management/overview'
      preLoaderRoute: typeof appOrgOrgIdeaManagementOverviewRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/custom-fields': {
      id: '/(app)/org/$org/idea-management/custom-fields'
      path: '/custom-fields'
      fullPath: '/org/$org/idea-management/custom-fields'
      preLoaderRoute: typeof appOrgOrgIdeaManagementCustomFieldsRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/component-gallery': {
      id: '/(app)/org/$org/idea-management/component-gallery'
      path: '/component-gallery'
      fullPath: '/org/$org/idea-management/component-gallery'
      preLoaderRoute: typeof appOrgOrgIdeaManagementComponentGalleryRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/settings/user-management': {
      id: '/(app)/org/$org/settings/user-management'
      path: '/user-management'
      fullPath: '/org/$org/settings/user-management'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/teams': {
      id: '/(app)/org/$org/settings/teams'
      path: '/teams'
      fullPath: '/org/$org/settings/teams'
      preLoaderRoute: typeof appOrgOrgSettingsTeamsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/subscriptions': {
      id: '/(app)/org/$org/settings/subscriptions'
      path: '/subscriptions'
      fullPath: '/org/$org/settings/subscriptions'
      preLoaderRoute: typeof appOrgOrgSettingsSubscriptionsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/skills': {
      id: '/(app)/org/$org/settings/skills'
      path: '/skills'
      fullPath: '/org/$org/settings/skills'
      preLoaderRoute: typeof appOrgOrgSettingsSkillsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/roles': {
      id: '/(app)/org/$org/settings/roles'
      path: '/roles'
      fullPath: '/org/$org/settings/roles'
      preLoaderRoute: typeof appOrgOrgSettingsRolesRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/people': {
      id: '/(app)/org/$org/settings/people'
      path: '/people'
      fullPath: '/org/$org/settings/people'
      preLoaderRoute: typeof appOrgOrgSettingsPeopleRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/organization': {
      id: '/(app)/org/$org/settings/organization'
      path: '/organization'
      fullPath: '/org/$org/settings/organization'
      preLoaderRoute: typeof appOrgOrgSettingsOrganizationRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/oauth-clients': {
      id: '/(app)/org/$org/settings/oauth-clients'
      path: '/oauth-clients'
      fullPath: '/org/$org/settings/oauth-clients'
      preLoaderRoute: typeof appOrgOrgSettingsOauthClientsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/location': {
      id: '/(app)/org/$org/settings/location'
      path: '/location'
      fullPath: '/org/$org/settings/location'
      preLoaderRoute: typeof appOrgOrgSettingsLocationRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/domains': {
      id: '/(app)/org/$org/settings/domains'
      path: '/domains'
      fullPath: '/org/$org/settings/domains'
      preLoaderRoute: typeof appOrgOrgSettingsDomainsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/connections': {
      id: '/(app)/org/$org/settings/connections'
      path: '/connections'
      fullPath: '/org/$org/settings/connections'
      preLoaderRoute: typeof appOrgOrgSettingsConnectionsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/capacity': {
      id: '/(app)/org/$org/settings/capacity'
      path: '/capacity'
      fullPath: '/org/$org/settings/capacity'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId': {
      id: '/(app)/org/$org/loop/$loopId'
      path: '/$loopId'
      fullPath: '/org/$org/loop/$loopId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopRouteRoute
    }
    '/(app)/org/$org/idea-management/portals': {
      id: '/(app)/org/$org/idea-management/portals'
      path: '/portals'
      fullPath: '/org/$org/idea-management/portals'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPortalsRouteRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/inbox': {
      id: '/(app)/org/$org/idea-management/inbox'
      path: '/inbox'
      fullPath: '/org/$org/idea-management/inbox'
      preLoaderRoute: typeof appOrgOrgIdeaManagementInboxRouteRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/settings/work-integrations/': {
      id: '/(app)/org/$org/settings/work-integrations/'
      path: '/work-integrations'
      fullPath: '/org/$org/settings/work-integrations/'
      preLoaderRoute: typeof appOrgOrgSettingsWorkIntegrationsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/user-management/': {
      id: '/(app)/org/$org/settings/user-management/'
      path: '/'
      fullPath: '/org/$org/settings/user-management/'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementRouteRoute
    }
    '/(app)/org/$org/settings/teams/': {
      id: '/(app)/org/$org/settings/teams/'
      path: '/'
      fullPath: '/org/$org/settings/teams/'
      preLoaderRoute: typeof appOrgOrgSettingsTeamsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsTeamsRouteRoute
    }
    '/(app)/org/$org/settings/subscriptions/': {
      id: '/(app)/org/$org/settings/subscriptions/'
      path: '/'
      fullPath: '/org/$org/settings/subscriptions/'
      preLoaderRoute: typeof appOrgOrgSettingsSubscriptionsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsSubscriptionsRouteRoute
    }
    '/(app)/org/$org/settings/skills/': {
      id: '/(app)/org/$org/settings/skills/'
      path: '/'
      fullPath: '/org/$org/settings/skills/'
      preLoaderRoute: typeof appOrgOrgSettingsSkillsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsSkillsRouteRoute
    }
    '/(app)/org/$org/settings/roles/': {
      id: '/(app)/org/$org/settings/roles/'
      path: '/'
      fullPath: '/org/$org/settings/roles/'
      preLoaderRoute: typeof appOrgOrgSettingsRolesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRolesRouteRoute
    }
    '/(app)/org/$org/settings/people/': {
      id: '/(app)/org/$org/settings/people/'
      path: '/'
      fullPath: '/org/$org/settings/people/'
      preLoaderRoute: typeof appOrgOrgSettingsPeopleIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsPeopleRouteRoute
    }
    '/(app)/org/$org/settings/organization/': {
      id: '/(app)/org/$org/settings/organization/'
      path: '/'
      fullPath: '/org/$org/settings/organization/'
      preLoaderRoute: typeof appOrgOrgSettingsOrganizationIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsOrganizationRouteRoute
    }
    '/(app)/org/$org/settings/oauth-clients/': {
      id: '/(app)/org/$org/settings/oauth-clients/'
      path: '/'
      fullPath: '/org/$org/settings/oauth-clients/'
      preLoaderRoute: typeof appOrgOrgSettingsOauthClientsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsOauthClientsRouteRoute
    }
    '/(app)/org/$org/settings/notifications/': {
      id: '/(app)/org/$org/settings/notifications/'
      path: '/notifications'
      fullPath: '/org/$org/settings/notifications/'
      preLoaderRoute: typeof appOrgOrgSettingsNotificationsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/location/': {
      id: '/(app)/org/$org/settings/location/'
      path: '/'
      fullPath: '/org/$org/settings/location/'
      preLoaderRoute: typeof appOrgOrgSettingsLocationIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsLocationRouteRoute
    }
    '/(app)/org/$org/settings/item-types/': {
      id: '/(app)/org/$org/settings/item-types/'
      path: '/item-types'
      fullPath: '/org/$org/settings/item-types/'
      preLoaderRoute: typeof appOrgOrgSettingsItemTypesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/effort-estimation/': {
      id: '/(app)/org/$org/settings/effort-estimation/'
      path: '/effort-estimation'
      fullPath: '/org/$org/settings/effort-estimation/'
      preLoaderRoute: typeof appOrgOrgSettingsEffortEstimationIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/domains/': {
      id: '/(app)/org/$org/settings/domains/'
      path: '/'
      fullPath: '/org/$org/settings/domains/'
      preLoaderRoute: typeof appOrgOrgSettingsDomainsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsDomainsRouteRoute
    }
    '/(app)/org/$org/settings/custom-item-status/': {
      id: '/(app)/org/$org/settings/custom-item-status/'
      path: '/custom-item-status'
      fullPath: '/org/$org/settings/custom-item-status/'
      preLoaderRoute: typeof appOrgOrgSettingsCustomItemStatusIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/custom-fields/': {
      id: '/(app)/org/$org/settings/custom-fields/'
      path: '/custom-fields'
      fullPath: '/org/$org/settings/custom-fields/'
      preLoaderRoute: typeof appOrgOrgSettingsCustomFieldsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/connections/': {
      id: '/(app)/org/$org/settings/connections/'
      path: '/'
      fullPath: '/org/$org/settings/connections/'
      preLoaderRoute: typeof appOrgOrgSettingsConnectionsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsConnectionsRouteRoute
    }
    '/(app)/org/$org/settings/capacity/': {
      id: '/(app)/org/$org/settings/capacity/'
      path: '/'
      fullPath: '/org/$org/settings/capacity/'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/settings/audit/': {
      id: '/(app)/org/$org/settings/audit/'
      path: '/audit'
      fullPath: '/org/$org/settings/audit/'
      preLoaderRoute: typeof appOrgOrgSettingsAuditIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/': {
      id: '/(app)/org/$org/loop/$loopId/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/idea-management/product-areas/': {
      id: '/(app)/org/$org/idea-management/product-areas/'
      path: '/product-areas'
      fullPath: '/org/$org/idea-management/product-areas/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementProductAreasIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/portals/': {
      id: '/(app)/org/$org/idea-management/portals/'
      path: '/'
      fullPath: '/org/$org/idea-management/portals/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPortalsIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementPortalsRouteRoute
    }
    '/(app)/org/$org/idea-management/inbox/': {
      id: '/(app)/org/$org/idea-management/inbox/'
      path: '/'
      fullPath: '/org/$org/idea-management/inbox/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementInboxIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementInboxRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/': {
      id: '/(app)/org/$org/idea-management/ideas/'
      path: '/ideas'
      fullPath: '/org/$org/idea-management/ideas/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/customers/': {
      id: '/(app)/org/$org/idea-management/customers/'
      path: '/customers'
      fullPath: '/org/$org/idea-management/customers/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementCustomersIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/settings/oauth-clients/$id': {
      id: '/(app)/org/$org/settings/oauth-clients/$id'
      path: '/$id'
      fullPath: '/org/$org/settings/oauth-clients/$id'
      preLoaderRoute: typeof appOrgOrgSettingsOauthClientsIdRouteImport
      parentRoute: typeof appOrgOrgSettingsOauthClientsRouteRoute
    }
    '/(app)/org/$org/settings/notifications/slack_app_health': {
      id: '/(app)/org/$org/settings/notifications/slack_app_health'
      path: '/notifications/slack_app_health'
      fullPath: '/org/$org/settings/notifications/slack_app_health'
      preLoaderRoute: typeof appOrgOrgSettingsNotificationsSlack_app_healthRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/work-integrations/$integrationId': {
      id: '/(app)/org/$org/settings/work-integrations/$integrationId'
      path: '/work-integrations/$integrationId'
      fullPath: '/org/$org/settings/work-integrations/$integrationId'
      preLoaderRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/user-management/users': {
      id: '/(app)/org/$org/settings/user-management/users'
      path: '/users'
      fullPath: '/org/$org/settings/user-management/users'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementRouteRoute
    }
    '/(app)/org/$org/settings/notifications/subscriptions': {
      id: '/(app)/org/$org/settings/notifications/subscriptions'
      path: '/notifications/subscriptions'
      fullPath: '/org/$org/settings/notifications/subscriptions'
      preLoaderRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations': {
      id: '/(app)/org/$org/loop/$loopId/visualizations'
      path: '/visualizations'
      fullPath: '/org/$org/loop/$loopId/visualizations'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/teams': {
      id: '/(app)/org/$org/loop/$loopId/teams'
      path: '/teams'
      fullPath: '/org/$org/loop/$loopId/teams'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdTeamsRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio': {
      id: '/(app)/org/$org/loop/$loopId/portfolio'
      path: '/portfolio'
      fullPath: '/org/$org/loop/$loopId/portfolio'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner': {
      id: '/(app)/org/$org/loop/$loopId/planner'
      path: '/planner'
      fullPath: '/org/$org/loop/$loopId/planner'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/insights': {
      id: '/(app)/org/$org/loop/$loopId/insights'
      path: '/insights'
      fullPath: '/org/$org/loop/$loopId/insights'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdInsightsRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/dashboard': {
      id: '/(app)/org/$org/loop/$loopId/dashboard'
      path: '/dashboard'
      fullPath: '/org/$org/loop/$loopId/dashboard'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdDashboardRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/settings/work-integrations/$integrationId/': {
      id: '/(app)/org/$org/settings/work-integrations/$integrationId/'
      path: '/'
      fullPath: '/org/$org/settings/work-integrations/$integrationId/'
      preLoaderRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute
    }
    '/(app)/org/$org/settings/user-management/users/': {
      id: '/(app)/org/$org/settings/user-management/users/'
      path: '/'
      fullPath: '/org/$org/settings/user-management/users/'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementUsersIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRoute
    }
    '/(app)/org/$org/settings/user-management/invites/': {
      id: '/(app)/org/$org/settings/user-management/invites/'
      path: '/invites'
      fullPath: '/org/$org/settings/user-management/invites/'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementInvitesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementRouteRoute
    }
    '/(app)/org/$org/settings/notifications/subscriptions/': {
      id: '/(app)/org/$org/settings/notifications/subscriptions/'
      path: '/'
      fullPath: '/org/$org/settings/notifications/subscriptions/'
      preLoaderRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/visualizations/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/teams/': {
      id: '/(app)/org/$org/loop/$loopId/teams/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/teams/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdTeamsIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdTeamsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/portfolio/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/': {
      id: '/(app)/org/$org/loop/$loopId/planner/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/planner/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/overview/': {
      id: '/(app)/org/$org/loop/$loopId/overview/'
      path: '/overview'
      fullPath: '/org/$org/loop/$loopId/overview/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdOverviewIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/integrations/': {
      id: '/(app)/org/$org/loop/$loopId/integrations/'
      path: '/integrations'
      fullPath: '/org/$org/loop/$loopId/integrations/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdIntegrationsIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/insights/': {
      id: '/(app)/org/$org/loop/$loopId/insights/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/insights/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdInsightsIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdInsightsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/dashboard/': {
      id: '/(app)/org/$org/loop/$loopId/dashboard/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/dashboard/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdDashboardIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdDashboardRouteRoute
    }
    '/(app)/org/$org/idea-management/product-areas/create/': {
      id: '/(app)/org/$org/idea-management/product-areas/create/'
      path: '/product-areas/create'
      fullPath: '/org/$org/idea-management/product-areas/create/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementProductAreasCreateIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/product-areas/$productAreaId/': {
      id: '/(app)/org/$org/idea-management/product-areas/$productAreaId/'
      path: '/product-areas/$productAreaId'
      fullPath: '/org/$org/idea-management/product-areas/$productAreaId/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/portals/create/': {
      id: '/(app)/org/$org/idea-management/portals/create/'
      path: '/create'
      fullPath: '/org/$org/idea-management/portals/create/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPortalsCreateIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementPortalsRouteRoute
    }
    '/(app)/org/$org/idea-management/portals/$portalId/': {
      id: '/(app)/org/$org/idea-management/portals/$portalId/'
      path: '/$portalId'
      fullPath: '/org/$org/idea-management/portals/$portalId/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPortalsPortalIdIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementPortalsRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/view/': {
      id: '/(app)/org/$org/idea-management/ideas/view/'
      path: '/ideas/view'
      fullPath: '/org/$org/idea-management/ideas/view/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasViewIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/create/': {
      id: '/(app)/org/$org/idea-management/ideas/create/'
      path: '/ideas/create'
      fullPath: '/org/$org/idea-management/ideas/create/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasCreateIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/completed/': {
      id: '/(app)/org/$org/idea-management/ideas/completed/'
      path: '/ideas/completed'
      fullPath: '/org/$org/idea-management/ideas/completed/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasCompletedIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/all/': {
      id: '/(app)/org/$org/idea-management/ideas/all/'
      path: '/ideas/all'
      fullPath: '/org/$org/idea-management/ideas/all/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasAllIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/settings/teams/team/$teamId': {
      id: '/(app)/org/$org/settings/teams/team/$teamId'
      path: '/team/$teamId'
      fullPath: '/org/$org/settings/teams/team/$teamId'
      preLoaderRoute: typeof appOrgOrgSettingsTeamsTeamTeamIdRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsTeamsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main'
      path: '/main'
      fullPath: '/org/$org/loop/$loopId/visualizations/main'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/sandbox': {
      id: '/(app)/org/$org/loop/$loopId/planner/sandbox'
      path: '/sandbox'
      fullPath: '/org/$org/loop/$loopId/planner/sandbox'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/insights/$insightId': {
      id: '/(app)/org/$org/loop/$loopId/insights/$insightId'
      path: '/$insightId'
      fullPath: '/org/$org/loop/$loopId/insights/$insightId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdInsightsInsightIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdInsightsRouteRoute
    }
    '/(app)/org/$org/settings/work-integrations/$integrationId/logs/': {
      id: '/(app)/org/$org/settings/work-integrations/$integrationId/logs/'
      path: '/logs'
      fullPath: '/org/$org/settings/work-integrations/$integrationId/logs/'
      preLoaderRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute
    }
    '/(app)/org/$org/settings/work-integrations/$integrationId/issues/': {
      id: '/(app)/org/$org/settings/work-integrations/$integrationId/issues/'
      path: '/issues'
      fullPath: '/org/$org/settings/work-integrations/$integrationId/issues/'
      preLoaderRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute
    }
    '/(app)/org/$org/settings/user-management/users/$userId/': {
      id: '/(app)/org/$org/settings/user-management/users/$userId/'
      path: '/$userId'
      fullPath: '/org/$org/settings/user-management/users/$userId/'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRoute
    }
    '/(app)/org/$org/settings/teams/team/$teamId/': {
      id: '/(app)/org/$org/settings/teams/team/$teamId/'
      path: '/'
      fullPath: '/org/$org/settings/teams/team/$teamId/'
      preLoaderRoute: typeof appOrgOrgSettingsTeamsTeamTeamIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsTeamsTeamTeamIdRouteRoute
    }
    '/(app)/org/$org/settings/notifications/subscriptions/idea-manager/': {
      id: '/(app)/org/$org/settings/notifications/subscriptions/idea-manager/'
      path: '/idea-manager'
      fullPath: '/org/$org/settings/notifications/subscriptions/idea-manager/'
      preLoaderRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRoute
    }
    '/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/': {
      id: '/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/'
      path: '/workload-scheme/$workloadSchemeId'
      fullPath: '/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/': {
      id: '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/'
      path: '/holiday-scheme/$holidaySchemeId'
      fullPath: '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/visualizations/main/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/sandbox/': {
      id: '/(app)/org/$org/loop/$loopId/planner/sandbox/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/planner/sandbox/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/dashboard/deliverables/': {
      id: '/(app)/org/$org/loop/$loopId/dashboard/deliverables/'
      path: '/deliverables'
      fullPath: '/org/$org/loop/$loopId/dashboard/deliverables/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdDashboardDeliverablesIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdDashboardRouteRoute
    }
    '/(app)/org/$org/idea-management/portals/$portalId/$formId/': {
      id: '/(app)/org/$org/idea-management/portals/$portalId/$formId/'
      path: '/$portalId/$formId'
      fullPath: '/org/$org/idea-management/portals/$portalId/$formId/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementPortalsRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/view/$viewId/': {
      id: '/(app)/org/$org/idea-management/ideas/view/$viewId/'
      path: '/ideas/view/$viewId'
      fullPath: '/org/$org/idea-management/ideas/view/$viewId/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasViewViewIdIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId'
      path: '/view/$viewId'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId': {
      id: '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId'
      path: '/scenario/$scenarioId'
      fullPath: '/org/$org/loop/$loopId/planner/scenario/$scenarioId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main/timeline/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/loop/$loopId/visualizations/main/timeline/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main/table/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main/table/'
      path: '/table'
      fullPath: '/org/$org/loop/$loopId/visualizations/main/table/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainTableIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/'
      path: '/swimlane'
      fullPath: '/org/$org/loop/$loopId/visualizations/main/swimlane/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId/'
      path: '/dashboard/$dashboardId'
      fullPath: '/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/': {
      id: '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/planner/scenario/$scenarioId/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/sandbox/timeline/': {
      id: '/(app)/org/$org/loop/$loopId/planner/sandbox/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/loop/$loopId/planner/sandbox/timeline/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/sandbox/table/': {
      id: '/(app)/org/$org/loop/$loopId/planner/sandbox/table/'
      path: '/table'
      fullPath: '/org/$org/loop/$loopId/planner/sandbox/table/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxTableIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/table/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/table/'
      path: '/table'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/table/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/'
      path: '/swimlane'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/': {
      id: '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/': {
      id: '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/'
      path: '/table'
      fullPath: '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute
    }
    '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png': {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
      fullPath: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf': {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
      fullPath: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png': {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
      fullPath: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf': {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
      fullPath: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId'
      path: '/timeline/preview/$visualizationId'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId'
      path: '/swimlane/preview/$visualizationId'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
  }
}

interface appOrgOrgIdeaManagementInboxRouteRouteChildren {
  appOrgOrgIdeaManagementInboxIndexRoute: typeof appOrgOrgIdeaManagementInboxIndexRoute
}

const appOrgOrgIdeaManagementInboxRouteRouteChildren: appOrgOrgIdeaManagementInboxRouteRouteChildren =
  {
    appOrgOrgIdeaManagementInboxIndexRoute:
      appOrgOrgIdeaManagementInboxIndexRoute,
  }

const appOrgOrgIdeaManagementInboxRouteRouteWithChildren =
  appOrgOrgIdeaManagementInboxRouteRoute._addFileChildren(
    appOrgOrgIdeaManagementInboxRouteRouteChildren,
  )

interface appOrgOrgIdeaManagementPortalsRouteRouteChildren {
  appOrgOrgIdeaManagementPortalsIndexRoute: typeof appOrgOrgIdeaManagementPortalsIndexRoute
  appOrgOrgIdeaManagementPortalsPortalIdIndexRoute: typeof appOrgOrgIdeaManagementPortalsPortalIdIndexRoute
  appOrgOrgIdeaManagementPortalsCreateIndexRoute: typeof appOrgOrgIdeaManagementPortalsCreateIndexRoute
  appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute: typeof appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute
}

const appOrgOrgIdeaManagementPortalsRouteRouteChildren: appOrgOrgIdeaManagementPortalsRouteRouteChildren =
  {
    appOrgOrgIdeaManagementPortalsIndexRoute:
      appOrgOrgIdeaManagementPortalsIndexRoute,
    appOrgOrgIdeaManagementPortalsPortalIdIndexRoute:
      appOrgOrgIdeaManagementPortalsPortalIdIndexRoute,
    appOrgOrgIdeaManagementPortalsCreateIndexRoute:
      appOrgOrgIdeaManagementPortalsCreateIndexRoute,
    appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute:
      appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute,
  }

const appOrgOrgIdeaManagementPortalsRouteRouteWithChildren =
  appOrgOrgIdeaManagementPortalsRouteRoute._addFileChildren(
    appOrgOrgIdeaManagementPortalsRouteRouteChildren,
  )

interface appOrgOrgIdeaManagementRouteRouteChildren {
  appOrgOrgIdeaManagementInboxRouteRoute: typeof appOrgOrgIdeaManagementInboxRouteRouteWithChildren
  appOrgOrgIdeaManagementPortalsRouteRoute: typeof appOrgOrgIdeaManagementPortalsRouteRouteWithChildren
  appOrgOrgIdeaManagementComponentGalleryRoute: typeof appOrgOrgIdeaManagementComponentGalleryRoute
  appOrgOrgIdeaManagementCustomFieldsRoute: typeof appOrgOrgIdeaManagementCustomFieldsRoute
  appOrgOrgIdeaManagementOverviewRoute: typeof appOrgOrgIdeaManagementOverviewRoute
  appOrgOrgIdeaManagementPriorityFrameworksRoute: typeof appOrgOrgIdeaManagementPriorityFrameworksRoute
  appOrgOrgIdeaManagementIndexRoute: typeof appOrgOrgIdeaManagementIndexRoute
  appOrgOrgIdeaManagementCustomersIndexRoute: typeof appOrgOrgIdeaManagementCustomersIndexRoute
  appOrgOrgIdeaManagementIdeasIndexRoute: typeof appOrgOrgIdeaManagementIdeasIndexRoute
  appOrgOrgIdeaManagementProductAreasIndexRoute: typeof appOrgOrgIdeaManagementProductAreasIndexRoute
  appOrgOrgIdeaManagementIdeasAllIndexRoute: typeof appOrgOrgIdeaManagementIdeasAllIndexRoute
  appOrgOrgIdeaManagementIdeasCompletedIndexRoute: typeof appOrgOrgIdeaManagementIdeasCompletedIndexRoute
  appOrgOrgIdeaManagementIdeasCreateIndexRoute: typeof appOrgOrgIdeaManagementIdeasCreateIndexRoute
  appOrgOrgIdeaManagementIdeasViewIndexRoute: typeof appOrgOrgIdeaManagementIdeasViewIndexRoute
  appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute: typeof appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute
  appOrgOrgIdeaManagementProductAreasCreateIndexRoute: typeof appOrgOrgIdeaManagementProductAreasCreateIndexRoute
  appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute: typeof appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute
}

const appOrgOrgIdeaManagementRouteRouteChildren: appOrgOrgIdeaManagementRouteRouteChildren =
  {
    appOrgOrgIdeaManagementInboxRouteRoute:
      appOrgOrgIdeaManagementInboxRouteRouteWithChildren,
    appOrgOrgIdeaManagementPortalsRouteRoute:
      appOrgOrgIdeaManagementPortalsRouteRouteWithChildren,
    appOrgOrgIdeaManagementComponentGalleryRoute:
      appOrgOrgIdeaManagementComponentGalleryRoute,
    appOrgOrgIdeaManagementCustomFieldsRoute:
      appOrgOrgIdeaManagementCustomFieldsRoute,
    appOrgOrgIdeaManagementOverviewRoute: appOrgOrgIdeaManagementOverviewRoute,
    appOrgOrgIdeaManagementPriorityFrameworksRoute:
      appOrgOrgIdeaManagementPriorityFrameworksRoute,
    appOrgOrgIdeaManagementIndexRoute: appOrgOrgIdeaManagementIndexRoute,
    appOrgOrgIdeaManagementCustomersIndexRoute:
      appOrgOrgIdeaManagementCustomersIndexRoute,
    appOrgOrgIdeaManagementIdeasIndexRoute:
      appOrgOrgIdeaManagementIdeasIndexRoute,
    appOrgOrgIdeaManagementProductAreasIndexRoute:
      appOrgOrgIdeaManagementProductAreasIndexRoute,
    appOrgOrgIdeaManagementIdeasAllIndexRoute:
      appOrgOrgIdeaManagementIdeasAllIndexRoute,
    appOrgOrgIdeaManagementIdeasCompletedIndexRoute:
      appOrgOrgIdeaManagementIdeasCompletedIndexRoute,
    appOrgOrgIdeaManagementIdeasCreateIndexRoute:
      appOrgOrgIdeaManagementIdeasCreateIndexRoute,
    appOrgOrgIdeaManagementIdeasViewIndexRoute:
      appOrgOrgIdeaManagementIdeasViewIndexRoute,
    appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute:
      appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute,
    appOrgOrgIdeaManagementProductAreasCreateIndexRoute:
      appOrgOrgIdeaManagementProductAreasCreateIndexRoute,
    appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute:
      appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute,
  }

const appOrgOrgIdeaManagementRouteRouteWithChildren =
  appOrgOrgIdeaManagementRouteRoute._addFileChildren(
    appOrgOrgIdeaManagementRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdDashboardRouteRouteChildren {
  appOrgOrgLoopLoopIdDashboardIndexRoute: typeof appOrgOrgLoopLoopIdDashboardIndexRoute
  appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute: typeof appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute
}

const appOrgOrgLoopLoopIdDashboardRouteRouteChildren: appOrgOrgLoopLoopIdDashboardRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdDashboardIndexRoute:
      appOrgOrgLoopLoopIdDashboardIndexRoute,
    appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute:
      appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute,
  }

const appOrgOrgLoopLoopIdDashboardRouteRouteWithChildren =
  appOrgOrgLoopLoopIdDashboardRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdDashboardRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdInsightsRouteRouteChildren {
  appOrgOrgLoopLoopIdInsightsInsightIdRouteRoute: typeof appOrgOrgLoopLoopIdInsightsInsightIdRouteRoute
  appOrgOrgLoopLoopIdInsightsIndexRoute: typeof appOrgOrgLoopLoopIdInsightsIndexRoute
}

const appOrgOrgLoopLoopIdInsightsRouteRouteChildren: appOrgOrgLoopLoopIdInsightsRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdInsightsInsightIdRouteRoute:
      appOrgOrgLoopLoopIdInsightsInsightIdRouteRoute,
    appOrgOrgLoopLoopIdInsightsIndexRoute:
      appOrgOrgLoopLoopIdInsightsIndexRoute,
  }

const appOrgOrgLoopLoopIdInsightsRouteRouteWithChildren =
  appOrgOrgLoopLoopIdInsightsRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdInsightsRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdPlannerSandboxRouteRouteChildren {
  appOrgOrgLoopLoopIdPlannerSandboxIndexRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxIndexRoute
  appOrgOrgLoopLoopIdPlannerSandboxTableIndexRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxTableIndexRoute
  appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRoute
}

const appOrgOrgLoopLoopIdPlannerSandboxRouteRouteChildren: appOrgOrgLoopLoopIdPlannerSandboxRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdPlannerSandboxIndexRoute:
      appOrgOrgLoopLoopIdPlannerSandboxIndexRoute,
    appOrgOrgLoopLoopIdPlannerSandboxTableIndexRoute:
      appOrgOrgLoopLoopIdPlannerSandboxTableIndexRoute,
    appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRoute:
      appOrgOrgLoopLoopIdPlannerSandboxTimelineIndexRoute,
  }

const appOrgOrgLoopLoopIdPlannerSandboxRouteRouteWithChildren =
  appOrgOrgLoopLoopIdPlannerSandboxRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdPlannerSandboxRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteChildren {
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute
}

const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteChildren: appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute:
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute,
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute:
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute,
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute:
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute,
  }

const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteWithChildren =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdPlannerRouteRouteChildren {
  appOrgOrgLoopLoopIdPlannerSandboxRouteRoute: typeof appOrgOrgLoopLoopIdPlannerSandboxRouteRouteWithChildren
  appOrgOrgLoopLoopIdPlannerIndexRoute: typeof appOrgOrgLoopLoopIdPlannerIndexRoute
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteWithChildren
}

const appOrgOrgLoopLoopIdPlannerRouteRouteChildren: appOrgOrgLoopLoopIdPlannerRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdPlannerSandboxRouteRoute:
      appOrgOrgLoopLoopIdPlannerSandboxRouteRouteWithChildren,
    appOrgOrgLoopLoopIdPlannerIndexRoute: appOrgOrgLoopLoopIdPlannerIndexRoute,
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute:
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteWithChildren,
  }

const appOrgOrgLoopLoopIdPlannerRouteRouteWithChildren =
  appOrgOrgLoopLoopIdPlannerRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdPlannerRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdPortfolioRouteRouteChildren {
  appOrgOrgLoopLoopIdPortfolioIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioIndexRoute
}

const appOrgOrgLoopLoopIdPortfolioRouteRouteChildren: appOrgOrgLoopLoopIdPortfolioRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdPortfolioIndexRoute:
      appOrgOrgLoopLoopIdPortfolioIndexRoute,
  }

const appOrgOrgLoopLoopIdPortfolioRouteRouteWithChildren =
  appOrgOrgLoopLoopIdPortfolioRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdPortfolioRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdTeamsRouteRouteChildren {
  appOrgOrgLoopLoopIdTeamsIndexRoute: typeof appOrgOrgLoopLoopIdTeamsIndexRoute
}

const appOrgOrgLoopLoopIdTeamsRouteRouteChildren: appOrgOrgLoopLoopIdTeamsRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdTeamsIndexRoute: appOrgOrgLoopLoopIdTeamsIndexRoute,
  }

const appOrgOrgLoopLoopIdTeamsRouteRouteWithChildren =
  appOrgOrgLoopLoopIdTeamsRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdTeamsRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdVisualizationsMainRouteRouteChildren {
  appOrgOrgLoopLoopIdVisualizationsMainIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainIndexRoute
  appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute
  appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute
  appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute
}

const appOrgOrgLoopLoopIdVisualizationsMainRouteRouteChildren: appOrgOrgLoopLoopIdVisualizationsMainRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdVisualizationsMainIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsMainIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute,
  }

const appOrgOrgLoopLoopIdVisualizationsMainRouteRouteWithChildren =
  appOrgOrgLoopLoopIdVisualizationsMainRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdVisualizationsMainRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteChildren {
  appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute
}

const appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteChildren: appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute,
  }

const appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteWithChildren =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdVisualizationsRouteRouteChildren {
  appOrgOrgLoopLoopIdVisualizationsMainRouteRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRouteWithChildren
  appOrgOrgLoopLoopIdVisualizationsIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteWithChildren
  appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRoute
}

const appOrgOrgLoopLoopIdVisualizationsRouteRouteChildren: appOrgOrgLoopLoopIdVisualizationsRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdVisualizationsMainRouteRoute:
      appOrgOrgLoopLoopIdVisualizationsMainRouteRouteWithChildren,
    appOrgOrgLoopLoopIdVisualizationsIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteWithChildren,
    appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsDashboardDashboardIdIndexRoute,
  }

const appOrgOrgLoopLoopIdVisualizationsRouteRouteWithChildren =
  appOrgOrgLoopLoopIdVisualizationsRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdVisualizationsRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdRouteRouteChildren {
  appOrgOrgLoopLoopIdDashboardRouteRoute: typeof appOrgOrgLoopLoopIdDashboardRouteRouteWithChildren
  appOrgOrgLoopLoopIdInsightsRouteRoute: typeof appOrgOrgLoopLoopIdInsightsRouteRouteWithChildren
  appOrgOrgLoopLoopIdPlannerRouteRoute: typeof appOrgOrgLoopLoopIdPlannerRouteRouteWithChildren
  appOrgOrgLoopLoopIdPortfolioRouteRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRouteWithChildren
  appOrgOrgLoopLoopIdTeamsRouteRoute: typeof appOrgOrgLoopLoopIdTeamsRouteRouteWithChildren
  appOrgOrgLoopLoopIdVisualizationsRouteRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRouteWithChildren
  appOrgOrgLoopLoopIdIndexRoute: typeof appOrgOrgLoopLoopIdIndexRoute
  appOrgOrgLoopLoopIdIntegrationsIndexRoute: typeof appOrgOrgLoopLoopIdIntegrationsIndexRoute
  appOrgOrgLoopLoopIdOverviewIndexRoute: typeof appOrgOrgLoopLoopIdOverviewIndexRoute
}

const appOrgOrgLoopLoopIdRouteRouteChildren: appOrgOrgLoopLoopIdRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdDashboardRouteRoute:
      appOrgOrgLoopLoopIdDashboardRouteRouteWithChildren,
    appOrgOrgLoopLoopIdInsightsRouteRoute:
      appOrgOrgLoopLoopIdInsightsRouteRouteWithChildren,
    appOrgOrgLoopLoopIdPlannerRouteRoute:
      appOrgOrgLoopLoopIdPlannerRouteRouteWithChildren,
    appOrgOrgLoopLoopIdPortfolioRouteRoute:
      appOrgOrgLoopLoopIdPortfolioRouteRouteWithChildren,
    appOrgOrgLoopLoopIdTeamsRouteRoute:
      appOrgOrgLoopLoopIdTeamsRouteRouteWithChildren,
    appOrgOrgLoopLoopIdVisualizationsRouteRoute:
      appOrgOrgLoopLoopIdVisualizationsRouteRouteWithChildren,
    appOrgOrgLoopLoopIdIndexRoute: appOrgOrgLoopLoopIdIndexRoute,
    appOrgOrgLoopLoopIdIntegrationsIndexRoute:
      appOrgOrgLoopLoopIdIntegrationsIndexRoute,
    appOrgOrgLoopLoopIdOverviewIndexRoute:
      appOrgOrgLoopLoopIdOverviewIndexRoute,
  }

const appOrgOrgLoopLoopIdRouteRouteWithChildren =
  appOrgOrgLoopLoopIdRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdRouteRouteChildren,
  )

interface appOrgOrgLoopRouteRouteChildren {
  appOrgOrgLoopLoopIdRouteRoute: typeof appOrgOrgLoopLoopIdRouteRouteWithChildren
}

const appOrgOrgLoopRouteRouteChildren: appOrgOrgLoopRouteRouteChildren = {
  appOrgOrgLoopLoopIdRouteRoute: appOrgOrgLoopLoopIdRouteRouteWithChildren,
}

const appOrgOrgLoopRouteRouteWithChildren =
  appOrgOrgLoopRouteRoute._addFileChildren(appOrgOrgLoopRouteRouteChildren)

interface appOrgOrgSettingsCapacityRouteRouteChildren {
  appOrgOrgSettingsCapacityIndexRoute: typeof appOrgOrgSettingsCapacityIndexRoute
  appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute: typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute: typeof appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute
}

const appOrgOrgSettingsCapacityRouteRouteChildren: appOrgOrgSettingsCapacityRouteRouteChildren =
  {
    appOrgOrgSettingsCapacityIndexRoute: appOrgOrgSettingsCapacityIndexRoute,
    appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute:
      appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute,
    appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute:
      appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute,
  }

const appOrgOrgSettingsCapacityRouteRouteWithChildren =
  appOrgOrgSettingsCapacityRouteRoute._addFileChildren(
    appOrgOrgSettingsCapacityRouteRouteChildren,
  )

interface appOrgOrgSettingsConnectionsRouteRouteChildren {
  appOrgOrgSettingsConnectionsIndexRoute: typeof appOrgOrgSettingsConnectionsIndexRoute
}

const appOrgOrgSettingsConnectionsRouteRouteChildren: appOrgOrgSettingsConnectionsRouteRouteChildren =
  {
    appOrgOrgSettingsConnectionsIndexRoute:
      appOrgOrgSettingsConnectionsIndexRoute,
  }

const appOrgOrgSettingsConnectionsRouteRouteWithChildren =
  appOrgOrgSettingsConnectionsRouteRoute._addFileChildren(
    appOrgOrgSettingsConnectionsRouteRouteChildren,
  )

interface appOrgOrgSettingsDomainsRouteRouteChildren {
  appOrgOrgSettingsDomainsIndexRoute: typeof appOrgOrgSettingsDomainsIndexRoute
}

const appOrgOrgSettingsDomainsRouteRouteChildren: appOrgOrgSettingsDomainsRouteRouteChildren =
  {
    appOrgOrgSettingsDomainsIndexRoute: appOrgOrgSettingsDomainsIndexRoute,
  }

const appOrgOrgSettingsDomainsRouteRouteWithChildren =
  appOrgOrgSettingsDomainsRouteRoute._addFileChildren(
    appOrgOrgSettingsDomainsRouteRouteChildren,
  )

interface appOrgOrgSettingsLocationRouteRouteChildren {
  appOrgOrgSettingsLocationIndexRoute: typeof appOrgOrgSettingsLocationIndexRoute
}

const appOrgOrgSettingsLocationRouteRouteChildren: appOrgOrgSettingsLocationRouteRouteChildren =
  {
    appOrgOrgSettingsLocationIndexRoute: appOrgOrgSettingsLocationIndexRoute,
  }

const appOrgOrgSettingsLocationRouteRouteWithChildren =
  appOrgOrgSettingsLocationRouteRoute._addFileChildren(
    appOrgOrgSettingsLocationRouteRouteChildren,
  )

interface appOrgOrgSettingsOauthClientsRouteRouteChildren {
  appOrgOrgSettingsOauthClientsIdRoute: typeof appOrgOrgSettingsOauthClientsIdRoute
  appOrgOrgSettingsOauthClientsIndexRoute: typeof appOrgOrgSettingsOauthClientsIndexRoute
}

const appOrgOrgSettingsOauthClientsRouteRouteChildren: appOrgOrgSettingsOauthClientsRouteRouteChildren =
  {
    appOrgOrgSettingsOauthClientsIdRoute: appOrgOrgSettingsOauthClientsIdRoute,
    appOrgOrgSettingsOauthClientsIndexRoute:
      appOrgOrgSettingsOauthClientsIndexRoute,
  }

const appOrgOrgSettingsOauthClientsRouteRouteWithChildren =
  appOrgOrgSettingsOauthClientsRouteRoute._addFileChildren(
    appOrgOrgSettingsOauthClientsRouteRouteChildren,
  )

interface appOrgOrgSettingsOrganizationRouteRouteChildren {
  appOrgOrgSettingsOrganizationIndexRoute: typeof appOrgOrgSettingsOrganizationIndexRoute
}

const appOrgOrgSettingsOrganizationRouteRouteChildren: appOrgOrgSettingsOrganizationRouteRouteChildren =
  {
    appOrgOrgSettingsOrganizationIndexRoute:
      appOrgOrgSettingsOrganizationIndexRoute,
  }

const appOrgOrgSettingsOrganizationRouteRouteWithChildren =
  appOrgOrgSettingsOrganizationRouteRoute._addFileChildren(
    appOrgOrgSettingsOrganizationRouteRouteChildren,
  )

interface appOrgOrgSettingsPeopleRouteRouteChildren {
  appOrgOrgSettingsPeopleIndexRoute: typeof appOrgOrgSettingsPeopleIndexRoute
}

const appOrgOrgSettingsPeopleRouteRouteChildren: appOrgOrgSettingsPeopleRouteRouteChildren =
  {
    appOrgOrgSettingsPeopleIndexRoute: appOrgOrgSettingsPeopleIndexRoute,
  }

const appOrgOrgSettingsPeopleRouteRouteWithChildren =
  appOrgOrgSettingsPeopleRouteRoute._addFileChildren(
    appOrgOrgSettingsPeopleRouteRouteChildren,
  )

interface appOrgOrgSettingsRolesRouteRouteChildren {
  appOrgOrgSettingsRolesIndexRoute: typeof appOrgOrgSettingsRolesIndexRoute
}

const appOrgOrgSettingsRolesRouteRouteChildren: appOrgOrgSettingsRolesRouteRouteChildren =
  {
    appOrgOrgSettingsRolesIndexRoute: appOrgOrgSettingsRolesIndexRoute,
  }

const appOrgOrgSettingsRolesRouteRouteWithChildren =
  appOrgOrgSettingsRolesRouteRoute._addFileChildren(
    appOrgOrgSettingsRolesRouteRouteChildren,
  )

interface appOrgOrgSettingsSkillsRouteRouteChildren {
  appOrgOrgSettingsSkillsIndexRoute: typeof appOrgOrgSettingsSkillsIndexRoute
}

const appOrgOrgSettingsSkillsRouteRouteChildren: appOrgOrgSettingsSkillsRouteRouteChildren =
  {
    appOrgOrgSettingsSkillsIndexRoute: appOrgOrgSettingsSkillsIndexRoute,
  }

const appOrgOrgSettingsSkillsRouteRouteWithChildren =
  appOrgOrgSettingsSkillsRouteRoute._addFileChildren(
    appOrgOrgSettingsSkillsRouteRouteChildren,
  )

interface appOrgOrgSettingsSubscriptionsRouteRouteChildren {
  appOrgOrgSettingsSubscriptionsIndexRoute: typeof appOrgOrgSettingsSubscriptionsIndexRoute
}

const appOrgOrgSettingsSubscriptionsRouteRouteChildren: appOrgOrgSettingsSubscriptionsRouteRouteChildren =
  {
    appOrgOrgSettingsSubscriptionsIndexRoute:
      appOrgOrgSettingsSubscriptionsIndexRoute,
  }

const appOrgOrgSettingsSubscriptionsRouteRouteWithChildren =
  appOrgOrgSettingsSubscriptionsRouteRoute._addFileChildren(
    appOrgOrgSettingsSubscriptionsRouteRouteChildren,
  )

interface appOrgOrgSettingsTeamsTeamTeamIdRouteRouteChildren {
  appOrgOrgSettingsTeamsTeamTeamIdIndexRoute: typeof appOrgOrgSettingsTeamsTeamTeamIdIndexRoute
}

const appOrgOrgSettingsTeamsTeamTeamIdRouteRouteChildren: appOrgOrgSettingsTeamsTeamTeamIdRouteRouteChildren =
  {
    appOrgOrgSettingsTeamsTeamTeamIdIndexRoute:
      appOrgOrgSettingsTeamsTeamTeamIdIndexRoute,
  }

const appOrgOrgSettingsTeamsTeamTeamIdRouteRouteWithChildren =
  appOrgOrgSettingsTeamsTeamTeamIdRouteRoute._addFileChildren(
    appOrgOrgSettingsTeamsTeamTeamIdRouteRouteChildren,
  )

interface appOrgOrgSettingsTeamsRouteRouteChildren {
  appOrgOrgSettingsTeamsIndexRoute: typeof appOrgOrgSettingsTeamsIndexRoute
  appOrgOrgSettingsTeamsTeamTeamIdRouteRoute: typeof appOrgOrgSettingsTeamsTeamTeamIdRouteRouteWithChildren
}

const appOrgOrgSettingsTeamsRouteRouteChildren: appOrgOrgSettingsTeamsRouteRouteChildren =
  {
    appOrgOrgSettingsTeamsIndexRoute: appOrgOrgSettingsTeamsIndexRoute,
    appOrgOrgSettingsTeamsTeamTeamIdRouteRoute:
      appOrgOrgSettingsTeamsTeamTeamIdRouteRouteWithChildren,
  }

const appOrgOrgSettingsTeamsRouteRouteWithChildren =
  appOrgOrgSettingsTeamsRouteRoute._addFileChildren(
    appOrgOrgSettingsTeamsRouteRouteChildren,
  )

interface appOrgOrgSettingsUserManagementUsersRouteRouteChildren {
  appOrgOrgSettingsUserManagementUsersIndexRoute: typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  appOrgOrgSettingsUserManagementUsersUserIdIndexRoute: typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
}

const appOrgOrgSettingsUserManagementUsersRouteRouteChildren: appOrgOrgSettingsUserManagementUsersRouteRouteChildren =
  {
    appOrgOrgSettingsUserManagementUsersIndexRoute:
      appOrgOrgSettingsUserManagementUsersIndexRoute,
    appOrgOrgSettingsUserManagementUsersUserIdIndexRoute:
      appOrgOrgSettingsUserManagementUsersUserIdIndexRoute,
  }

const appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren =
  appOrgOrgSettingsUserManagementUsersRouteRoute._addFileChildren(
    appOrgOrgSettingsUserManagementUsersRouteRouteChildren,
  )

interface appOrgOrgSettingsUserManagementRouteRouteChildren {
  appOrgOrgSettingsUserManagementUsersRouteRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren
  appOrgOrgSettingsUserManagementIndexRoute: typeof appOrgOrgSettingsUserManagementIndexRoute
  appOrgOrgSettingsUserManagementInvitesIndexRoute: typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
}

const appOrgOrgSettingsUserManagementRouteRouteChildren: appOrgOrgSettingsUserManagementRouteRouteChildren =
  {
    appOrgOrgSettingsUserManagementUsersRouteRoute:
      appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren,
    appOrgOrgSettingsUserManagementIndexRoute:
      appOrgOrgSettingsUserManagementIndexRoute,
    appOrgOrgSettingsUserManagementInvitesIndexRoute:
      appOrgOrgSettingsUserManagementInvitesIndexRoute,
  }

const appOrgOrgSettingsUserManagementRouteRouteWithChildren =
  appOrgOrgSettingsUserManagementRouteRoute._addFileChildren(
    appOrgOrgSettingsUserManagementRouteRouteChildren,
  )

interface appOrgOrgSettingsNotificationsSubscriptionsRouteRouteChildren {
  appOrgOrgSettingsNotificationsSubscriptionsIndexRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsIndexRoute
  appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute
}

const appOrgOrgSettingsNotificationsSubscriptionsRouteRouteChildren: appOrgOrgSettingsNotificationsSubscriptionsRouteRouteChildren =
  {
    appOrgOrgSettingsNotificationsSubscriptionsIndexRoute:
      appOrgOrgSettingsNotificationsSubscriptionsIndexRoute,
    appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute:
      appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute,
  }

const appOrgOrgSettingsNotificationsSubscriptionsRouteRouteWithChildren =
  appOrgOrgSettingsNotificationsSubscriptionsRouteRoute._addFileChildren(
    appOrgOrgSettingsNotificationsSubscriptionsRouteRouteChildren,
  )

interface appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteChildren {
  appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute
  appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute
  appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute
}

const appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteChildren: appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteChildren =
  {
    appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute:
      appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute,
    appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute:
      appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute,
    appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute:
      appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute,
  }

const appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteWithChildren =
  appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute._addFileChildren(
    appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteChildren,
  )

interface appOrgOrgSettingsRouteRouteChildren {
  appOrgOrgSettingsCapacityRouteRoute: typeof appOrgOrgSettingsCapacityRouteRouteWithChildren
  appOrgOrgSettingsConnectionsRouteRoute: typeof appOrgOrgSettingsConnectionsRouteRouteWithChildren
  appOrgOrgSettingsDomainsRouteRoute: typeof appOrgOrgSettingsDomainsRouteRouteWithChildren
  appOrgOrgSettingsLocationRouteRoute: typeof appOrgOrgSettingsLocationRouteRouteWithChildren
  appOrgOrgSettingsOauthClientsRouteRoute: typeof appOrgOrgSettingsOauthClientsRouteRouteWithChildren
  appOrgOrgSettingsOrganizationRouteRoute: typeof appOrgOrgSettingsOrganizationRouteRouteWithChildren
  appOrgOrgSettingsPeopleRouteRoute: typeof appOrgOrgSettingsPeopleRouteRouteWithChildren
  appOrgOrgSettingsRolesRouteRoute: typeof appOrgOrgSettingsRolesRouteRouteWithChildren
  appOrgOrgSettingsSkillsRouteRoute: typeof appOrgOrgSettingsSkillsRouteRouteWithChildren
  appOrgOrgSettingsSubscriptionsRouteRoute: typeof appOrgOrgSettingsSubscriptionsRouteRouteWithChildren
  appOrgOrgSettingsTeamsRouteRoute: typeof appOrgOrgSettingsTeamsRouteRouteWithChildren
  appOrgOrgSettingsUserManagementRouteRoute: typeof appOrgOrgSettingsUserManagementRouteRouteWithChildren
  appOrgOrgSettingsIndexRoute: typeof appOrgOrgSettingsIndexRoute
  appOrgOrgSettingsNotificationsSubscriptionsRouteRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRouteWithChildren
  appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteWithChildren
  appOrgOrgSettingsNotificationsSlack_app_healthRoute: typeof appOrgOrgSettingsNotificationsSlack_app_healthRoute
  appOrgOrgSettingsAuditIndexRoute: typeof appOrgOrgSettingsAuditIndexRoute
  appOrgOrgSettingsCustomFieldsIndexRoute: typeof appOrgOrgSettingsCustomFieldsIndexRoute
  appOrgOrgSettingsCustomItemStatusIndexRoute: typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  appOrgOrgSettingsEffortEstimationIndexRoute: typeof appOrgOrgSettingsEffortEstimationIndexRoute
  appOrgOrgSettingsItemTypesIndexRoute: typeof appOrgOrgSettingsItemTypesIndexRoute
  appOrgOrgSettingsNotificationsIndexRoute: typeof appOrgOrgSettingsNotificationsIndexRoute
  appOrgOrgSettingsWorkIntegrationsIndexRoute: typeof appOrgOrgSettingsWorkIntegrationsIndexRoute
}

const appOrgOrgSettingsRouteRouteChildren: appOrgOrgSettingsRouteRouteChildren =
  {
    appOrgOrgSettingsCapacityRouteRoute:
      appOrgOrgSettingsCapacityRouteRouteWithChildren,
    appOrgOrgSettingsConnectionsRouteRoute:
      appOrgOrgSettingsConnectionsRouteRouteWithChildren,
    appOrgOrgSettingsDomainsRouteRoute:
      appOrgOrgSettingsDomainsRouteRouteWithChildren,
    appOrgOrgSettingsLocationRouteRoute:
      appOrgOrgSettingsLocationRouteRouteWithChildren,
    appOrgOrgSettingsOauthClientsRouteRoute:
      appOrgOrgSettingsOauthClientsRouteRouteWithChildren,
    appOrgOrgSettingsOrganizationRouteRoute:
      appOrgOrgSettingsOrganizationRouteRouteWithChildren,
    appOrgOrgSettingsPeopleRouteRoute:
      appOrgOrgSettingsPeopleRouteRouteWithChildren,
    appOrgOrgSettingsRolesRouteRoute:
      appOrgOrgSettingsRolesRouteRouteWithChildren,
    appOrgOrgSettingsSkillsRouteRoute:
      appOrgOrgSettingsSkillsRouteRouteWithChildren,
    appOrgOrgSettingsSubscriptionsRouteRoute:
      appOrgOrgSettingsSubscriptionsRouteRouteWithChildren,
    appOrgOrgSettingsTeamsRouteRoute:
      appOrgOrgSettingsTeamsRouteRouteWithChildren,
    appOrgOrgSettingsUserManagementRouteRoute:
      appOrgOrgSettingsUserManagementRouteRouteWithChildren,
    appOrgOrgSettingsIndexRoute: appOrgOrgSettingsIndexRoute,
    appOrgOrgSettingsNotificationsSubscriptionsRouteRoute:
      appOrgOrgSettingsNotificationsSubscriptionsRouteRouteWithChildren,
    appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute:
      appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteWithChildren,
    appOrgOrgSettingsNotificationsSlack_app_healthRoute:
      appOrgOrgSettingsNotificationsSlack_app_healthRoute,
    appOrgOrgSettingsAuditIndexRoute: appOrgOrgSettingsAuditIndexRoute,
    appOrgOrgSettingsCustomFieldsIndexRoute:
      appOrgOrgSettingsCustomFieldsIndexRoute,
    appOrgOrgSettingsCustomItemStatusIndexRoute:
      appOrgOrgSettingsCustomItemStatusIndexRoute,
    appOrgOrgSettingsEffortEstimationIndexRoute:
      appOrgOrgSettingsEffortEstimationIndexRoute,
    appOrgOrgSettingsItemTypesIndexRoute: appOrgOrgSettingsItemTypesIndexRoute,
    appOrgOrgSettingsNotificationsIndexRoute:
      appOrgOrgSettingsNotificationsIndexRoute,
    appOrgOrgSettingsWorkIntegrationsIndexRoute:
      appOrgOrgSettingsWorkIntegrationsIndexRoute,
  }

const appOrgOrgSettingsRouteRouteWithChildren =
  appOrgOrgSettingsRouteRoute._addFileChildren(
    appOrgOrgSettingsRouteRouteChildren,
  )

interface appOrgOrgRouteRouteChildren {
  appOrgOrgIdeaManagementRouteRoute: typeof appOrgOrgIdeaManagementRouteRouteWithChildren
  appOrgOrgLoopRouteRoute: typeof appOrgOrgLoopRouteRouteWithChildren
  appOrgOrgSettingsRouteRoute: typeof appOrgOrgSettingsRouteRouteWithChildren
  appOrgOrgIndexRoute: typeof appOrgOrgIndexRoute
  appOrgOrgAllItemsIndexRoute: typeof appOrgOrgAllItemsIndexRoute
  appOrgOrgNangoPlaygroundIndexRoute: typeof appOrgOrgNangoPlaygroundIndexRoute
  appOrgOrgNotificationsIndexRoute: typeof appOrgOrgNotificationsIndexRoute
  appOrgOrgObjectivesIndexRoute: typeof appOrgOrgObjectivesIndexRoute
  appOrgOrgVisualizationsIndexRoute: typeof appOrgOrgVisualizationsIndexRoute
}

const appOrgOrgRouteRouteChildren: appOrgOrgRouteRouteChildren = {
  appOrgOrgIdeaManagementRouteRoute:
    appOrgOrgIdeaManagementRouteRouteWithChildren,
  appOrgOrgLoopRouteRoute: appOrgOrgLoopRouteRouteWithChildren,
  appOrgOrgSettingsRouteRoute: appOrgOrgSettingsRouteRouteWithChildren,
  appOrgOrgIndexRoute: appOrgOrgIndexRoute,
  appOrgOrgAllItemsIndexRoute: appOrgOrgAllItemsIndexRoute,
  appOrgOrgNangoPlaygroundIndexRoute: appOrgOrgNangoPlaygroundIndexRoute,
  appOrgOrgNotificationsIndexRoute: appOrgOrgNotificationsIndexRoute,
  appOrgOrgObjectivesIndexRoute: appOrgOrgObjectivesIndexRoute,
  appOrgOrgVisualizationsIndexRoute: appOrgOrgVisualizationsIndexRoute,
}

const appOrgOrgRouteRouteWithChildren = appOrgOrgRouteRoute._addFileChildren(
  appOrgOrgRouteRouteChildren,
)

interface appRouteRouteChildren {
  appIndexRoute: typeof appIndexRoute
  appOrgOrgRouteRoute: typeof appOrgOrgRouteRouteWithChildren
  appInvitesIndexRoute: typeof appInvitesIndexRoute
  appOrgIndexRoute: typeof appOrgIndexRoute
  appProfileIndexRoute: typeof appProfileIndexRoute
  appIntegrationsJiraCallbackRoute: typeof appIntegrationsJiraCallbackRoute
  appIntegrationsSlackCallbackRoute: typeof appIntegrationsSlackCallbackRoute
  appOrgIdOrgIdSplatRoute: typeof appOrgIdOrgIdSplatRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appIndexRoute: appIndexRoute,
  appOrgOrgRouteRoute: appOrgOrgRouteRouteWithChildren,
  appInvitesIndexRoute: appInvitesIndexRoute,
  appOrgIndexRoute: appOrgIndexRoute,
  appProfileIndexRoute: appProfileIndexRoute,
  appIntegrationsJiraCallbackRoute: appIntegrationsJiraCallbackRoute,
  appIntegrationsSlackCallbackRoute: appIntegrationsSlackCallbackRoute,
  appOrgIdOrgIdSplatRoute: appOrgIdOrgIdSplatRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface unauthenticatedOrganizationsInvitesRouteRouteChildren {
  unauthenticatedOrganizationsInvitesAcceptRoute: typeof unauthenticatedOrganizationsInvitesAcceptRoute
  unauthenticatedOrganizationsInvitesErrorIndexRoute: typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
}

const unauthenticatedOrganizationsInvitesRouteRouteChildren: unauthenticatedOrganizationsInvitesRouteRouteChildren =
  {
    unauthenticatedOrganizationsInvitesAcceptRoute:
      unauthenticatedOrganizationsInvitesAcceptRoute,
    unauthenticatedOrganizationsInvitesErrorIndexRoute:
      unauthenticatedOrganizationsInvitesErrorIndexRoute,
  }

const unauthenticatedOrganizationsInvitesRouteRouteWithChildren =
  unauthenticatedOrganizationsInvitesRouteRoute._addFileChildren(
    unauthenticatedOrganizationsInvitesRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,
  unauthenticatedSignupRoute: unauthenticatedSignupRoute,
  unauthenticatedTermsRoute: unauthenticatedTermsRoute,
  unauthenticatedOrganizationsInvitesRouteRoute:
    unauthenticatedOrganizationsInvitesRouteRouteWithChildren,
  unauthenticatedLinkIdentityCallbackRoute:
    unauthenticatedLinkIdentityCallbackRoute,
  unauthenticatedOrganizationsStartRoute:
    unauthenticatedOrganizationsStartRoute,
  unauthenticatedLinkIdentityIndexRoute: unauthenticatedLinkIdentityIndexRoute,
  unauthenticatedOrganizationSelectorIndexRoute:
    unauthenticatedOrganizationSelectorIndexRoute,
  unauthenticatedPublishedV1SwimlaneLinkIdRoute:
    unauthenticatedPublishedV1SwimlaneLinkIdRoute,
  unauthenticatedPublishedV1TimelineLinkIdRoute:
    unauthenticatedPublishedV1TimelineLinkIdRoute,
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute:
    unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute,
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute:
    unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute,
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute:
    unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute,
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute:
    unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
